/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AccessRequirementService {
  /**
   *
   */
  static getAccessRequirements(options: IRequestOptions = {}): Promise<AccessRequirementDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/access-requirements/get-access-requirements';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdateAccessRequirementModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/access-requirements/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AuthService {
  /**
   *
   */
  static login(
    params: {
      /** requestBody */
      body?: LoginModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/auth/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static refreshToken(
    params: {
      /** requestBody */
      body?: RefreshTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefreshTokenResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/auth/refresh-token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendTwoFactorCode(
    params: {
      /** requestBody */
      body?: SendTwoFactorCodeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/auth/send-two-factor-code';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static verifyTwoFactorCode(
    params: {
      /** requestBody */
      body?: VerifyTwoFactorCodeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/auth/verify-two-factor-code';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AuthenticatorService {
  /**
   *
   */
  static status(options: IRequestOptions = {}): Promise<AuthenticatorStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/authenticator/status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static beginEnrollment(options: IRequestOptions = {}): Promise<AuthenticatorSetupModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/authenticator/begin-enrollment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static confirmEnrollment(
    params: {
      /** requestBody */
      body?: AuthenticatorCodeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthenticatorRecoveryCodesModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/authenticator/confirm-enrollment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static regenerateRecoveryCodes(
    params: {
      /** requestBody */
      body?: AuthenticatorCodeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthenticatorRecoveryCodesModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/authenticator/regenerate-recovery-codes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BaggageReconciliationService {
  /**
   *
   */
  static getEmployeeReconciliationDetails(
    params: {
      /**  */
      employeeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaggageReconciliationDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/baggage-reconciliations/get-employee-reconciliation-details/{employeeId}';
      url = url.replace('{employeeId}', params['employeeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEmployeeReconciliationPaymentRecords(
    params: {
      /**  */
      employeeId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaggageReconciliationPaymentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/baggage-reconciliations/get-employee-reconciliation-payment-records';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        EmployeeId: params['employeeId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static logReconciliationRecord(
    params: {
      /** requestBody */
      body?: LogBaggageReconciliationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/baggage-reconciliations/log-reconciliation-record';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BaggageTariffService {
  /**
   *
   */
  static getBaggageTariffs(
    params: {
      /**  */
      baseTicketClassId?: string;
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaggageTariffDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/get-baggage-tariffs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BaseTicketClassId: params['baseTicketClassId'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveBaggageTariff(
    params: {
      /** requestBody */
      body?: SaveBaggageTariffModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/save-baggage-tariff';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: BaggageTariffExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: BaggageTariffExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      fileName: string;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseImportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/import';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['fileName']) {
        if (Object.prototype.toString.call(params['fileName']) === '[object Array]') {
          for (const item of params['fileName']) {
            data.append('FileName', item as any);
          }
        } else {
          data.append('FileName', params['fileName'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getImportColumns(options: IRequestOptions = {}): Promise<BaseImportColumn[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/baggage-tariffs/get-import-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BaseTariffParameterService {
  /**
   *
   */
  static getTariffParameters(
    params: {
      /**  */
      searchText?: string;
      /**  */
      isStandard?: boolean;
      /**  */
      isActive?: boolean;
      /** Person = 1, Age = 2, Profession = 3, PhysicalConditions = 4, Special = 5, TicketConditions = 6, CarteLoyalty = 7, Partner = 8, Regularisation = 9 */
      category?: TariffCategory;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseTariffParameterDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/common/base-tariff-parameters/get-tariff-parameters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        IsStandard: params['isStandard'],
        IsActive: params['isActive'],
        Category: params['category'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(options: IRequestOptions = {}): Promise<TariffAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/common/base-tariff-parameters/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBaseTariffParameterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/common/base-tariff-parameters/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBaseTariffParameterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/common/base-tariff-parameters/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/common/base-tariff-parameters/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BasicTariffService {
  /**
   *
   */
  static getBasicTariffs(
    params: {
      /**  */
      baseTicketClassId?: string;
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BasicTariffDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/get-basic-tariffs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BaseTicketClassId: params['baseTicketClassId'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateBasicTariff(
    params: {
      /** requestBody */
      body?: UpdateBasicTariffModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/update-basic-tariff';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveSegmentTariffParameter(
    params: {
      /** requestBody */
      body?: SaveSegmentTariffParameterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/save-segment-tariff-parameter';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSegmentTariffParameters(
    params: {
      /**  */
      ticketTariffId: string;
      /**  */
      searchText?: string;
      /** Person = 1, Age = 2, Profession = 3, PhysicalConditions = 4, Special = 5, TicketConditions = 6, CarteLoyalty = 7, Partner = 8, Regularisation = 9 */
      category?: TariffCategory;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SegmentTariffParameterDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/get-segment-tariff-parameters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TicketTariffId: params['ticketTariffId'],
        SearchText: params['searchText'],
        Category: params['category'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createSegment(
    params: {
      /** requestBody */
      body?: CreateSegmentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/create-segment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      segmentId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/delete/{segmentId}';
      url = url.replace('{segmentId}', params['segmentId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: BasicTariffExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: BasicTariffExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      fileName: string;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseImportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/import';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['fileName']) {
        if (Object.prototype.toString.call(params['fileName']) === '[object Array]') {
          for (const item of params['fileName']) {
            data.append('FileName', item as any);
          }
        } else {
          data.append('FileName', params['fileName'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getImportColumns(options: IRequestOptions = {}): Promise<BaseImportColumn[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/basic-tariffs/get-import-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BookingDetailService {
  /**
   *
   */
  static getBookingBasicInfo(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BasicBookingInfoModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-booking-basic-info/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBookingDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-booking-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBookingDetailsForPrinting(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-booking-details-for-printing/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sellerOptions(options: IRequestOptions = {}): Promise<SellerOptionsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/seller-options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBookingPaging(
    params: {
      /**  */
      bookingRefNo?: string;
      /**  */
      receiptRefNo?: string;
      /**  */
      bookingDate?: string;
      /**  */
      departureDate?: string;
      /**  */
      passengerName?: string;
      /** Booked = 1, Cancelled = 2, PaymentPending = 3 */
      status?: BookingStatus;
      /**  */
      registerId?: string;
      /**  */
      cashierId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-booking-paging';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BookingRefNo: params['bookingRefNo'],
        ReceiptRefNo: params['receiptRefNo'],
        BookingDate: params['bookingDate'],
        DepartureDate: params['departureDate'],
        PassengerName: params['passengerName'],
        Status: params['status'],
        RegisterId: params['registerId'],
        CashierId: params['cashierId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketPaging(
    params: {
      /**  */
      tripId?: string;
      /**  */
      sourceId?: string;
      /**  */
      destinationId?: string;
      /**  */
      bookingId?: string;
      /**  */
      bookingRefNo?: string;
      /**  */
      ticketRefNo?: string;
      /**  */
      passengerFirstName?: string;
      /**  */
      passengerLastName?: string;
      /** Issued = 1, CheckedIn = 2, Cancelled = 3, Pending = 4, Expired = 5, UnUsed = 6, Boarded = 7, Waiting = 8, Free = 9, CancelRequested = 10, Replaced = 11 */
      ticketStatus?: TicketStatus;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-ticket-paging';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TripId: params['tripId'],
        SourceId: params['sourceId'],
        DestinationId: params['destinationId'],
        BookingId: params['bookingId'],
        BookingRefNo: params['bookingRefNo'],
        TicketRefNo: params['ticketRefNo'],
        PassengerFirstName: params['passengerFirstName'],
        PassengerLastName: params['passengerLastName'],
        TicketStatus: params['ticketStatus'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getConflictTicketPaging(
    params: {
      /**  */
      tripId?: string;
      /**  */
      sourceId?: string;
      /**  */
      destinationId?: string;
      /**  */
      bookingId?: string;
      /**  */
      bookingRefNo?: string;
      /**  */
      ticketRefNo?: string;
      /**  */
      passengerFirstName?: string;
      /**  */
      passengerLastName?: string;
      /** Issued = 1, CheckedIn = 2, Cancelled = 3, Pending = 4, Expired = 5, UnUsed = 6, Boarded = 7, Waiting = 8, Free = 9, CancelRequested = 10, Replaced = 11 */
      ticketStatus?: TicketStatus;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-conflict-ticket-paging';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TripId: params['tripId'],
        SourceId: params['sourceId'],
        DestinationId: params['destinationId'],
        BookingId: params['bookingId'],
        BookingRefNo: params['bookingRefNo'],
        TicketRefNo: params['ticketRefNo'],
        PassengerFirstName: params['passengerFirstName'],
        PassengerLastName: params['passengerLastName'],
        TicketStatus: params['ticketStatus'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketDetails(
    params: {
      /**  */
      tripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-ticket-details/{tripId}';
      url = url.replace('{tripId}', params['tripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketBaggage(
    params: {
      /**  */
      bookingTripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketBaggageModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-ticket-baggage/{bookingTripId}';
      url = url.replace('{bookingTripId}', params['bookingTripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketPassenger(
    params: {
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-ticket-passenger/{ticketId}';
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateTicketPassenger(
    params: {
      /** requestBody */
      body?: UpdatePassengerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/update-ticket-passenger';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketPassengerIdentity(
    params: {
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerIdentityDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-ticket-passenger-identity/{ticketId}';
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateTicketPassengerIdentity(
    params: {
      /** requestBody */
      body?: UpdatePassengerIdentityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/update-ticket-passenger-identity';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReconciliationPaymentRecords(
    params: {
      /** requestBody */
      body?: GetReconciliationPaymentPagingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReconciliationBookingPaymentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/get-reconciliation-payment-records';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendTicketSmsMessage(
    params: {
      /** requestBody */
      body?: SendTicketSmsMessageRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/send-ticket-sms-message';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static downloadBookingPdf(
    params: {
      /**  */
      bookingId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-details/download-booking-pdf/{bookingId}';
      url = url.replace('{bookingId}', params['bookingId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BookingHistoryService {
  /**
   *
   */
  static getBookingHistories(
    params: {
      /**  */
      bookingId?: string;
      /**  */
      entityId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingHistoryDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-histories/get-booking-histories';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BookingId: params['bookingId'],
        EntityId: params['entityId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BookingPassengerService {
  /**
   *
   */
  static passengerAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      tariffParameterId?: string;
      /**  */
      passengerId?: string;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/passenger-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Limit: params['limit'],
        TariffParameterId: params['tariffParameterId'],
        PassengerId: params['passengerId'],
        SearchText: params['searchText']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPassengers(
    params: {
      /**  */
      ids?: any | null[];
      /**  */
      searchText?: string;
      /**  */
      countryId?: string;
      /** Male = 1, Female = 2 */
      gender?: PassengerGender;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/get-passengers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Ids: params['ids'],
        SearchText: params['searchText'],
        CountryId: params['countryId'],
        Gender: params['gender'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPassengerDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/get-passenger-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdatePassengerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static block(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/block/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static unblock(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/unblock/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportPassengerRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportPassengerRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPassengerIdentityDetails(
    params: {
      /**  */
      passengerId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerIdentityDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/get-passenger-identity-details/{passengerId}';
      url = url.replace('{passengerId}', params['passengerId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updatePassengerIdentity(
    params: {
      /** requestBody */
      body?: UpdatePassengerIdentityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/update-passenger-identity';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripPassengers(
    params: {
      /**  */
      tripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetTripPassengerResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/get-trip-passengers/{tripId}';
      url = url.replace('{tripId}', params['tripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static passengerHistory(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PassengerProfileHistoryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/passenger-history/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static withoutPhoneCounts(
    params: {
      /**  */
      from?: string;
      /**  */
      to?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WithoutPhoneCountModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/without-phone-counts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { from: params['from'], to: params['to'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static invalidPhones(options: IRequestOptions = {}): Promise<PassengerInvalidPhoneModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/invalid-phones';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static correctPhone(
    params: {
      /** requestBody */
      body?: CorrectPassengerPhoneRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/booking-passengers/correct-phone';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BookingPaymentDetailService {
  /**
   *
   */
  static getRegisterPaymentRecords(
    params: {
      /**  */
      registerId?: string;
      /**  */
      bookingRefNo?: string;
      /**  */
      receiptRefNo?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterBookingPaymentModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/payment-details/get-register-payment-records';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RegisterId: params['registerId'],
        BookingRefNo: params['bookingRefNo'],
        ReceiptRefNo: params['receiptRefNo'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReconciliationPaymentAmount(
    params: {
      /** requestBody */
      body?: GetReconciliationPaymentAmountRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/payment-details/get-reconciliation-payment-amount';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BoxCategoryService {
  /**
   *
   */
  static getBoxCategories(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxCategoryPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/get-box-categories';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxCategoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxCategoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxCategoryAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/get-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportBoxCategoryRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportBoxCategoryRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-categories/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BoxTypeService {
  /**
   *
   */
  static getBoxTypes(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxTypePagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/get-box-types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxTypeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxTypeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxTypeAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/get-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportBoxTypeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportBoxTypeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-types/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BoxVolumeService {
  /**
   *
   */
  static getBoxVolumes(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxVolumePagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/get-box-volumes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxVolumeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxVolumeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxVolumeAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/get-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportBoxVolumeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportBoxVolumeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-volumes/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BoxWeightService {
  /**
   *
   */
  static getBoxWeights(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxWeightPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/get-box-weights';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxWeightModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBoxWeightModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoxWeightAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/get-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportBoxWeightRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportBoxWeightRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/box-weights/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BusService {
  /**
   *
   */
  static getBuses(
    params: {
      /**  */
      busName?: string;
      /**  */
      plateNumber?: string;
      /**  */
      serialNo?: string;
      /**  */
      seatingModelId?: string;
      /**  */
      modelId?: string;
      /**  */
      brandId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/get-buses';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BusName: params['busName'],
        PlateNumber: params['plateNumber'],
        SerialNo: params['serialNo'],
        SeatingModelId: params['seatingModelId'],
        ModelId: params['modelId'],
        BrandId: params['brandId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: BusExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: BusExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/buses/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BusBrandService {
  /**
   *
   */
  static getBusBrands(
    params: {
      /**  */
      brandName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusBrandDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-brands/get-bus-brands';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BrandName: params['brandName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusBrandModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-brands/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusBrandModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-brands/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-brands/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      brandName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusBrandAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-brands/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { BrandName: params['brandName'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BusDocumentService {
  /**
   *
   */
  static getBusDocuments(
    params: {
      /**  */
      fileName?: string;
      /**  */
      fileUrl?: string;
      /**  */
      busId?: string;
      /**  */
      plateNumber?: string;
      /**  */
      busName?: string;
      /**  */
      serialNo?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusDocumentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-documents/get-bus-documents';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FileName: params['fileName'],
        FileUrl: params['fileUrl'],
        BusId: params['busId'],
        PlateNumber: params['plateNumber'],
        BusName: params['busName'],
        SerialNo: params['serialNo'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusDocumentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-documents/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusDocumentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-documents/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-documents/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BusInsuranceService {
  /**
   *
   */
  static getBusInsurances(
    params: {
      /**  */
      policyNumber?: string;
      /**  */
      plateNumber?: string;
      /**  */
      busName?: string;
      /**  */
      serialNo?: string;
      /**  */
      busId: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusInsuranceDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurances/get-bus-insurances';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PolicyNumber: params['policyNumber'],
        PlateNumber: params['plateNumber'],
        BusName: params['busName'],
        SerialNo: params['serialNo'],
        BusId: params['busId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusInsuranceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurances/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusInsuranceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurances/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurances/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BusInsurerService {
  /**
   *
   */
  static getInsurers(
    params: {
      /**  */
      insurerName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusInsurerDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurers/get-insurers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        InsurerName: params['insurerName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateInsurerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurers/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateInsurerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurers/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurers/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      insurerName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusInsurerAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-insurers/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { InsurerName: params['insurerName'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BusModelService {
  /**
   *
   */
  static getBusModels(
    params: {
      /**  */
      modelName?: string;
      /**  */
      busBrandId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusModelDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-models/get-bus-models';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ModelName: params['modelName'],
        BusBrandId: params['busBrandId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusModelModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-models/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusModelModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-models/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-models/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      modelName?: string;
      /**  */
      busBrandId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusModelAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-models/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { ModelName: params['modelName'], BusBrandId: params['busBrandId'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class BusStationMappingService {
  /**
   *
   */
  static getBusStationMappings(
    params: {
      /**  */
      busId: string;
      /**  */
      stationId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusStationMappingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-station-mappings/get-bus-station-mappings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BusId: params['busId'],
        StationId: params['stationId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: BusStationMappingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-station-mappings/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: BusStationMappingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-station-mappings/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-station-mappings/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BusStatusService {
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      statusName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusStatusModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-statuses/get-status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StatusName: params['statusName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusStatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-statuses/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusStatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-statuses/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-statuses/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BusStatusHistoryService {
  /**
   *
   */
  static getStatusHistories(
    params: {
      /**  */
      busStatusId?: string;
      /**  */
      busId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BusStatusHistoryModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-status-histories/get-status-histories';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BusStatusId: params['busStatusId'],
        BusId: params['busId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateBusStatusHistoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-status-histories/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateBusStatusHistoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-status-histories/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/bus-status-histories/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CityService {
  /**
   *
   */
  static getCities(
    params: {
      /**  */
      cityName?: string;
      /**  */
      cityCode?: string;
      /**  */
      countryId?: string;
      /**  */
      regionId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/cities/get-cities';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CityName: params['cityName'],
        CityCode: params['cityCode'],
        CountryId: params['countryId'],
        RegionId: params['regionId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateCityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/cities/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateCityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/cities/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/cities/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyService {
  /**
   *
   */
  static getCompanies(
    params: {
      /**  */
      ids?: any | null[];
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-companies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Ids: params['ids'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getNameById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-name-by-id/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutoCompletion(
    params: {
      /**  */
      ids?: any | null[];
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyAutoCompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-auto-completion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Ids: params['ids'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyBasicInfo(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyBasicInfo> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-company-basic-info/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyForUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-company-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdateCompanyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static blockUnblock(
    params: {
      /** requestBody */
      body?: BlockUnBlockCompanyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/block-unblock';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static activeTicketSelling(
    params: {
      /** requestBody */
      body?: ActiveTicketSellingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/active-ticket-selling';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static register(
    params: {
      /** requestBody */
      body?: RegisterCompanyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/register';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: CompanyExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: CompanyExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/companies/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyAccountService {
  /**
   *
   */
  static getCompanyAccounts(
    params: {
      /**  */
      accountOwner?: string;
      /**  */
      accountNumber?: string;
      /** Payment = 1, CashInCashOut = 2 */
      accountType?: CompanyAccountType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyAccountDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-accounts/get-company-accounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        AccountOwner: params['accountOwner'],
        AccountNumber: params['accountNumber'],
        AccountType: params['accountType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyAccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-accounts/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyAccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-accounts/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-accounts/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      countryId?: string;
      /**  */
      paymentPartnerId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyAccountAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-accounts/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { CountryId: params['countryId'], PaymentPartnerId: params['paymentPartnerId'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyDashboardReportService {
  /**
   *
   */
  static getReports(
    params: {
      /** Daily = 1, Monthly = 2 */
      type?: CompanyDashboardReportType;
      /**  */
      startDate?: string;
      /**  */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyDashboardReportModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-dashboard-reports/get-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Type: params['type'], StartDate: params['startDate'], Year: params['year'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyNotificationService {
  /**
   *
   */
  static getNotifications(
    params: {
      /**  */
      searchText?: string;
      /** AdminPortal = 1, POS = 2, Transport = 3 */
      applicationType?: MtopoApplication;
      /** TicketGenerated = 1, ReturnTicketGenerated = 2, CancelTicket = 3, ShipmentBooking = 4, ShipmentReached = 5, ShipmentInClaim = 6, TripsDelayed = 7, TripsCancelled = 8, CheckinDone = 9, Parking = 10, Baggage = 11, FreeSeatBooked = 12, FreeSeatRelease = 13, FreeSeatReleaseReminder = 14, TicketExpiration = 15, FreeSeatBookedReturn = 16, TripThreshold = 17, SeatingModelReassignment = 18, ShipmentAssigned = 19, ShipmentDeparted = 20, ShipmentDelivered = 21, TicketFree = 22, CancelRequest = 23 */
      notificationModule?: NotificationModuleType;
      /** SMS = 1, Email = 2 */
      notificationType?: NotificationCategoryType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyNotificationDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-notifications/get-notifications';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        ApplicationType: params['applicationType'],
        NotificationModule: params['notificationModule'],
        NotificationType: params['notificationType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyNotificationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-notifications/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyNotificationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-notifications/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-notifications/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanySaleReportService {
  /**
   *
   */
  static ticketSaleReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
      /**  */
      countryId?: string;
      /**  */
      registerId?: string;
      /**  */
      cashierId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanySaleTicketReportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-sale-reports/ticket-sale-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FromDate: params['fromDate'],
        ToDate: params['toDate'],
        CountryId: params['countryId'],
        RegisterId: params['registerId'],
        CashierId: params['cashierId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportSaleReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-sale-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportSaleReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-sale-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanySettingService {
  /**
   *
   */
  static getSettings(options: IRequestOptions = {}): Promise<CompanySettingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CompanySettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCarrierCode(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-carrier-code';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getIntervalDays(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-interval-days';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketModificationLimitTime(
    params: {
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-ticket-modification-limit-time/{companyId}';
      url = url.replace('{companyId}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripBoardingLimitTime(
    params: {
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-trip-boarding-limit-time/{companyId}';
      url = url.replace('{companyId}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyTicketInfo(
    params: {
      /**  */
      companyId: string;
      /**  */
      countryId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyTicketInfoModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-settings/get-company-ticket-info/{companyId}/{countryId}';
      url = url.replace('{companyId}', params['companyId'] + '');
      url = url.replace('{countryId}', params['countryId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CompanySmsServiceUrlService {
  /**
   *
   */
  static getServiceUrls(
    params: {
      /**  */
      countryCode?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanySmsServiceUrlDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/get-service-urls';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CountryCode: params['countryCode'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetailById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanySmsServiceUrlDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/get-detail-by-id/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetailByCountryCode(
    params: {
      /**  */
      countryCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanySmsServiceUrlDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/get-detail-by-country-code/{countryCode}';
      url = url.replace('{countryCode}', params['countryCode'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CompanySmsServiceUrlModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: CompanySmsServiceUrlModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanySmsSettings(
    params: {
      /**  */
      countryCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanySmsSetting> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/get-company-sms-settings/{countryCode}';
      url = url.replace('{countryCode}', params['countryCode'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static ping(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/company-sms-service-urls/ping';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyTicketClassService {
  /**
   *
   */
  static getCompanyTicketClasses(
    params: {
      /**  */
      ticketClassId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyTicketClassDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/company-ticket-classes/get-company-ticket-classes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TicketClassId: params['ticketClassId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(options: IRequestOptions = {}): Promise<TicketClassAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/company-ticket-classes/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyTicketClassModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/company-ticket-classes/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateCompanyTicketClassModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/company-ticket-classes/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/company-ticket-classes/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyTripDetailReportService {
  /**
   *
   */
  static getTripDetailReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
      /**  */
      tripName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyTripDetailReportDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-detail-reports/get-trip-detail-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FromDate: params['fromDate'],
        ToDate: params['toDate'],
        TripName: params['tripName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportTripDetailReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-detail-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportTripDetailReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-detail-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyTripIncomeReportService {
  /**
   *
   */
  static getTripIncomeReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyTripIncomeReportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-income-reports/get-trip-income-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FromDate: params['fromDate'],
        ToDate: params['toDate'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ExportTripIncomeReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-income-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportTripIncomeReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-income-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyTripReportService {
  /**
   *
   */
  static getTripReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
      /**  */
      routeId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyTripReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-reports/get-trip-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { FromDate: params['fromDate'], ToDate: params['toDate'], RouteId: params['routeId'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoutesByUsers(options: IRequestOptions = {}): Promise<GuidBaseAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-reports/get-routes-by-users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: CompanyTripReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: CompanyTripReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/company-trip-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyUnEarnedRevenueReportService {
  /**
   *
   */
  static getReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyUnEarnedRevenueReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unearned-reports/get-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { FromDate: params['fromDate'], ToDate: params['toDate'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: CompanyUnEarnedRevenueReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unearned-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: CompanyUnEarnedRevenueReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unearned-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyUserService {
  /**
   *
   */
  static getCompanyUsers(
    params: {
      /**  */
      searchText?: string;
      /**  */
      employeeType?: EmployeeType;
      /**  */
      userName?: string;
      /**  */
      jobTitle?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyUserDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-company-users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        EmployeeType: params['employeeType'],
        UserName: params['userName'],
        JobTitle: params['jobTitle'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDriversAndCoDrivers(
    params: {
      /**  */
      searchText?: string;
      /**  */
      employeeType?: EmployeeType;
      /**  */
      userName?: string;
      /**  */
      jobTitle?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyUserDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-drivers-and-co-drivers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        EmployeeType: params['employeeType'],
        UserName: params['userName'],
        JobTitle: params['jobTitle'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyUserDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateCompanyUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdateCompanyUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserByRoles(
    params: {
      /**  */
      roles?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserBasicInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-user-by-roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roles: params['roles'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserByUsername(
    params: {
      /**  */
      userName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserBasicInfoModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-user-by-username';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userName: params['userName'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: CompanyUserExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: CompanyUserExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserPermissions(
    params: {
      /**  */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/get-user-permissions/{userId}';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateUserPermissions(
    params: {
      /** requestBody */
      body?: UpdateUserPermissionsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/company-users/update-user-permissions';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CountryService {
  /**
   *
   */
  static getCountries(
    params: {
      /**  */
      countryName?: string;
      /**  */
      isOperatingOnly?: boolean;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountryModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/countries/get-countries';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CountryName: params['countryName'],
        IsOperatingOnly: params['isOperatingOnly'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateCountryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/countries/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateCountryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/countries/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/countries/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTimezone(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/countries/get-timezone/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class CreditNoteService {
  /**
   *
   */
  static creditNotes(
    params: {
      /**  */
      status?: string;
      /**  */
      issuedFrom?: string;
      /**  */
      issuedTo?: string;
      /**  */
      number?: string;
      /**  */
      phoneCode?: string;
      /**  */
      phoneNumber?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreditNoteListResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/credit-notes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Status: params['status'],
        IssuedFrom: params['issuedFrom'],
        IssuedTo: params['issuedTo'],
        Number: params['number'],
        PhoneCode: params['phoneCode'],
        PhoneNumber: params['phoneNumber'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static creditNotes1(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreditNoteDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/credit-notes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class DiscountService {
  /**
   *
   */
  static getDiscounts(
    params: {
      /**  */
      name?: string;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /** Passenger = 1, TicketClass = 3, TariffParameter = 4 */
      beneficiaryType?: DiscountBeneficiaryType;
      /** Shipment = 1, Baggage = 2, Trip = 3 */
      targetType?: DiscountTargetType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DiscountDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/discounts/get-discounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        BeneficiaryType: params['beneficiaryType'],
        TargetType: params['targetType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: DiscountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/discounts/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DiscountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/discounts/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DiscountModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/discounts/get-entity-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/discounts/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class EmailService {
  /**
   *
   */
  static sendMail(
    params: {
      /** requestBody */
      body?: SendMailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/emails/send-mail';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class EmailMessageService {
  /**
   *
   */
  static getEmailMessages(
    params: {
      /**  */
      subject?: string;
      /**  */
      toEmail?: string;
      /**  */
      id?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmailMessagePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-messages/get-email-messages';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Subject: params['subject'],
        ToEmail: params['toEmail'],
        Id: params['id'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmailMessage> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-messages/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class EmailTemplateService {
  /**
   *
   */
  static getEmailTemplates(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmailTemplateModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-templates/get-email-templates';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static emailTemplateNames(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-templates/email-template-names';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: EmailTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-templates/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: EmailTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-templates/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/email-templates/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class EmployeeCategoryService {
  /**
   *
   */
  static getAutocompletionList(options: IRequestOptions = {}): Promise<EmployeeCategoryAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/employee-categories/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class GlobalCashierSellingAssignmentService {
  /**
   *
   */
  static getSellingAssignments(
    params: {
      /**  */
      cashierId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalCashierSellingAssignmentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/selling-assignments/get-selling-assignments';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CashierId: params['cashierId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveSellingAssignment(
    params: {
      /** requestBody */
      body?: UpdateGlobalCashierSellingAssignmentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/selling-assignments/save-selling-assignment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSellingAssignment(
    params: {
      /**  */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalCashierSellingAssignmentDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/selling-assignments/get-selling-assignment/{userId}';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class GlobalDiscountService {
  /**
   *
   */
  static getDiscounts(
    params: {
      /**  */
      promoCode?: string;
      /**  */
      shortDescription?: string;
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalDiscountDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/get-discounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PromoCode: params['promoCode'],
        ShortDescription: params['shortDescription'],
        FromDate: params['fromDate'],
        ToDate: params['toDate'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateGlobalDiscountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateGlobalDiscountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdateGlobalDiscountModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static discountUserAutocompletion(
    params: {
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConektoUserAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/global-discounts/discount-user-autocompletion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class GlobalUserService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateGlobalUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdateGlobalUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGlobalUsers(
    params: {
      /**  */
      searchText?: string;
      /**  */
      roleId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalUserDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/get-global-users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        RoleId: params['roleId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUsersByRoles(
    params: {
      /**  */
      roles?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserBasicInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/get-users-by-roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roles: params['roles'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGlobalUser(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalUserDetailDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/get-global-user/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReportingManagers(
    params: {
      /**  */
      searchText?: string;
      /**  */
      editingUserId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReportingManagerModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/get-reporting-managers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        EditingUserId: params['editingUserId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: GlobalUserExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: GlobalUserExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/global-users/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class LianeAdvertisingService {
  /**
   *
   */
  static getPaging(
    params: {
      /**  */
      title?: string;
      /** BeforeLogin = 1, Home = 2 */
      advertisingScreen?: AdvertisingScreen;
      /** Slider = 1, StaticPanel = 2 */
      advertisingType?: AdvertisingType;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /**  */
      isActive?: boolean;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LianeAdvertisingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/get-paging';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        AdvertisingScreen: params['advertisingScreen'],
        AdvertisingType: params['advertisingType'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        IsActive: params['isActive'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateLianeAdvertisingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateLianeAdvertisingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdateLianeAdvertisingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBaseTripAutoCompletion(
    params: {
      /**  */
      companyId?: string;
      /**  */
      limit?: number;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AdvertisingTripAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/get-base-trip-auto-completion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { CompanyId: params['companyId'], Limit: params['limit'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static uploadVideo(
    params: {
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VideoUploadResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-advertising/upload-video';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class LianeBookingManagementService {
  /**
   *
   */
  static getBookings(
    params: {
      /**  */
      bookingRefNo?: string;
      /**  */
      receiptRefNo?: string;
      /**  */
      bookingDate?: string;
      /**  */
      departureDate?: string;
      /**  */
      passengerName?: string;
      /** Booked = 1, Cancelled = 2, PaymentPending = 3 */
      status?: BookingStatus;
      /** Cash = 1, MobileMoney = 2, CreditCard = 3, Miles = 4, Credit = 5, Wallet = 6, CreditNote = 7 */
      payMode?: BookingPayMode;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LianeBookingPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-bookings/get-bookings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BookingRefNo: params['bookingRefNo'],
        ReceiptRefNo: params['receiptRefNo'],
        BookingDate: params['bookingDate'],
        DepartureDate: params['departureDate'],
        PassengerName: params['passengerName'],
        Status: params['status'],
        PayMode: params['payMode'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTickets(
    params: {
      /**  */
      sourceId?: string;
      /**  */
      destinationId?: string;
      /**  */
      lianeBookingId?: string;
      /**  */
      bookingRefNo?: string;
      /**  */
      ticketRefNo?: string;
      /**  */
      passengerFirstName?: string;
      /**  */
      passengerLastName?: string;
      /** Issued = 1, CheckedIn = 2, Cancelled = 3, Pending = 4, Expired = 5, UnUsed = 6, Boarded = 7, Waiting = 8, Free = 9, CancelRequested = 10, Replaced = 11 */
      status?: TicketStatus;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LianeTicketPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-bookings/get-tickets';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SourceId: params['sourceId'],
        DestinationId: params['destinationId'],
        LianeBookingId: params['lianeBookingId'],
        BookingRefNo: params['bookingRefNo'],
        TicketRefNo: params['ticketRefNo'],
        PassengerFirstName: params['passengerFirstName'],
        PassengerLastName: params['passengerLastName'],
        Status: params['status'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class LianeCommonSettingService {
  /**
   *
   */
  static getSetting(options: IRequestOptions = {}): Promise<CreateUpdateLianeCommonSettingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-common-settings/get-setting';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateLianeCommonSettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-common-settings/update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class LianeUserFollowUpDetailService {
  /**
   *
   */
  static getFollowUpDetails(
    params: {
      /**  */
      lianeUserId?: string;
      /**  */
      comment?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LianeUserFollowUpDetailDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/get-follow-up-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        LianeUserId: params['lianeUserId'],
        Comment: params['comment'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateUserFollowUpDetailModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateUserFollowUpDetailModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdateUserFollowUpDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportConektoUserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-follow-up-details/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class LianeUserManagementService {
  /**
   *
   */
  static getLianeUsers(
    params: {
      /**  */
      fullName?: string;
      /**  */
      phoneNumber?: string;
      /**  */
      emailAddress?: string;
      /**  */
      registrationFromDate?: string;
      /**  */
      registrationToDate?: string;
      /**  */
      phoneNumberConfirmed?: boolean;
      /**  */
      emailConfirmed?: boolean;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConektoUserPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-users/get-liane-users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FullName: params['fullName'],
        PhoneNumber: params['phoneNumber'],
        EmailAddress: params['emailAddress'],
        RegistrationFromDate: params['registrationFromDate'],
        RegistrationToDate: params['registrationToDate'],
        PhoneNumberConfirmed: params['phoneNumberConfirmed'],
        EmailConfirmed: params['emailConfirmed'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static blockWallet(
    params: {
      /**  */
      id: string;
      /**  */
      isBlocked: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-users/block-wallet/{id}/{isBlocked}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{isBlocked}', params['isBlocked'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConektoUserDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-users/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: ExportConektoUserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/liane-users/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class MediaService {
  /**
   *
   */
  static uploadImage(
    params: {
      /**  */
      container: number;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FileUploadResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/medias/upload-image';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['container']) {
        if (Object.prototype.toString.call(params['container']) === '[object Array]') {
          for (const item of params['container']) {
            data.append('Container', item as any);
          }
        } else {
          data.append('Container', params['container'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static uploadDocument(
    params: {
      /**  */
      container: number;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FileUploadResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/medias/upload-document';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['container']) {
        if (Object.prototype.toString.call(params['container']) === '[object Array]') {
          for (const item of params['container']) {
            data.append('Container', item as any);
          }
        } else {
          data.append('Container', params['container'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static download(
    params: {
      /**  */
      fileUrl?: string;
      /**  */
      container?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/medias/download';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fileUrl: params['fileUrl'], container: params['container'] };

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class NotificationService {
  /**
   *
   */
  static getNotifications(
    params: {
      /**  */
      companyId?: string;
      /**  */
      senderId?: string;
      /**  */
      toUserId?: string;
      /**  */
      isEnable?: boolean;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotificationPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/notifications/get-notifications';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CompanyId: params['companyId'],
        SenderId: params['senderId'],
        ToUserId: params['toUserId'],
        IsEnable: params['isEnable'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendNotifications(
    params: {
      /** requestBody */
      body?: SendNotificationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/notifications/send-notifications';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateStatus(
    params: {
      /**  */
      id: string;
      /**  */
      status: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/notifications/update-status/{id}/{status}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{status}', params['status'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class NotificationContactService {
  /**
   *
   */
  static getNotificationContacts(
    params: {
      /** SMS = 1, Email = 2 */
      notificationType?: NotificationContactType;
      /**  */
      contactName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportNotificationContactDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/notification-contacts/get-notification-contacts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        NotificationType: params['notificationType'],
        ContactName: params['contactName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TransportNotificationContactModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/notification-contacts/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TransportNotificationContactModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/notification-contacts/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/notification-contacts/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PartnerAccountService {
  /**
   *
   */
  static getPartnerAccounts(
    params: {
      /**  */
      utilityPartnerId?: string;
      /** BankAccount = 1, MobileMoneyAccount = 2 */
      partnerAccountType?: PartnerAccountType;
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerAccountDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-accounts/get-partner-accounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UtilityPartnerId: params['utilityPartnerId'],
        PartnerAccountType: params['partnerAccountType'],
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdatePartnerAccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-accounts/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdatePartnerAccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-accounts/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-accounts/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static activeInactive(
    params: {
      /** requestBody */
      body?: ActiveInactivePartnerAccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-accounts/active-inactive';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PartnerConnectivityService {
  /**
   *
   */
  static getPartnerConnectivityList(
    params: {
      /**  */
      partnerId?: string;
      /**  */
      ipAddress?: string;
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerConnectivityDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-connectivity/get-partner-connectivity-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PartnerId: params['partnerId'],
        IpAddress: params['ipAddress'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdatePartnerConnectivityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-connectivity/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdatePartnerConnectivityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-connectivity/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerConnectivityDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-connectivity/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/partner-connectivity/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PasswordPolicyService {
  /**
   *
   */
  static getValidationMessages(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/password-policies/get-validation-messages';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPasswordPolicy(options: IRequestOptions = {}): Promise<PasswordPolicyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/password-policies/get-password-policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdatePasswordPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/password-policies/update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PaymentPartnerService {
  /**
   *
   */
  static companyPartners(
    params: {
      /** MNO = 1, Bank = 2 */
      partnerType?: PaymentPartnerType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyPaymentPartnersResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/company-partners';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { partnerType: params['partnerType'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPaymentPartners(
    params: {
      /**  */
      searchText?: string;
      /** MNO = 1, Bank = 2 */
      partnerType?: PaymentPartnerType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentPartnerDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/get-payment-partners';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        PartnerType: params['partnerType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdatePaymentPartnerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdatePaymentPartnerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentPartnerDetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: PaymentPartnerExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: PaymentPartnerExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      countryId?: string;
      /** MNO = 1, Bank = 2 */
      paymentPartnerType?: PaymentPartnerType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentPartnerAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/payment-partners/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { CountryId: params['countryId'], PaymentPartnerType: params['paymentPartnerType'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class PdfTemplateService {
  /**
   *
   */
  static getPdfTemplates(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PdfPagingResponsePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/pdf-templates/get-pdf-templates';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPdfTemplateNames(options: IRequestOptions = {}): Promise<PdfTemplateNameModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/pdf-templates/get-pdf-template-names';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdatePdfTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/pdf-templates/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdatePdfTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/pdf-templates/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/pdf-templates/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PlanService {
  /**
   *
   */
  static getPlans(
    params: {
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PlanModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/get-plans';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSubscriptionPlans(
    params: {
      /** Monekto = 1, Conekto-Retail = 2, Conekto-Transport = 3 */
      app: SystemApp;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PlanSubscriptionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/get-subscription-plans/{app}';
      url = url.replace('{app}', params['app'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSubscribeViewModel(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PlanSubscribeViewModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/get-subscribe-view-model/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static subscribe(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/subscribe/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static renew(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/renew/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdatePlanModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdatePlanModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdatePlanModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/plans/get-entity-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class RegionService {
  /**
   *
   */
  static getRegions(
    params: {
      /**  */
      regionName?: string;
      /**  */
      countryId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegionModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/regions/get-regions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RegionName: params['regionName'],
        CountryId: params['countryId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateRegionModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/regions/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateRegionModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/regions/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/regions/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class RegisterService {
  /**
   *
   */
  static getRegisters(
    params: {
      /**  */
      name?: string;
      /** Ready = 1, Open = 2, Closed = 3 */
      status?: RegisterStatus;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterPagingResponseModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/get-registers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Status: params['status'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRegisterDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/get-register-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateRegisterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UpdateRegisterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static removecashierfromregister(
    params: {
      /**  */
      id: string;
      /**  */
      cashierid: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/removecashierfromregister/{id}/{cashierid}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{cashierid}', params['cashierid'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPin(
    params: {
      /**  */
      registerId: string;
      /**  */
      cashierId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/reset-pin/{registerId}/{cashierId}';
      url = url.replace('{registerId}', params['registerId'] + '');
      url = url.replace('{cashierId}', params['cashierId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateStatus(
    params: {
      /** requestBody */
      body?: UpdateRegisterStatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/update-status';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentBalance(
    params: {
      /**  */
      registerId: string;
      /** Deposit = 1, Withdraw = 2 */
      type: UpdateRegisterBalanceType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/get-current-balance/{registerId}/{type}';
      url = url.replace('{registerId}', params['registerId'] + '');
      url = url.replace('{type}', params['type'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateCurrentBalance(
    params: {
      /** requestBody */
      body?: UpdateRegisterBalanceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/update-current-balance';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCashierRegisters(options: IRequestOptions = {}): Promise<CashierRegisterModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/cashier-registers/get-cashier-registers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class RegisterReconciliationService {
  /**
   *
   */
  static getReconciliationDetails(
    params: {
      /**  */
      registerId?: string;
      /**  */
      cashierId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterReconciliationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/reconciliations/get-reconciliation-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { RegisterId: params['registerId'], CashierId: params['cashierId'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReconciliationPaymentRecords(
    params: {
      /**  */
      registerId?: string;
      /**  */
      cashierId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReconciliationBookingPaymentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/reconciliations/get-reconciliation-payment-records';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RegisterId: params['registerId'],
        CashierId: params['cashierId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static logReconciliationRecord(
    params: {
      /** requestBody */
      body?: LogReconciliationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/registers/reconciliations/log-reconciliation-record';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class RoleService {
  /**
   *
   */
  static getGlobalRoles(options: IRequestOptions = {}): Promise<RoleDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-global-roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGlobalPermissions(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-global-permissions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateGlobalRole(
    params: {
      /** requestBody */
      body?: UpdateGlobalRoleModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/update-global-role';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-role-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyRoles(
    params: {
      /**  */
      name?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-company-roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyRoleNames(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-company-role-names';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyPermissions(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/get-company-permissions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createCompanyRole(
    params: {
      /** requestBody */
      body?: CreateCompanyRoleModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/create-company-role';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateCompanyRole(
    params: {
      /** requestBody */
      body?: UpdateCompanyRoleModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/update-company-role';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteCompanyRole(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/roles/delete-company-role/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class RouteService {
  /**
   *
   */
  static getRoutes(
    params: {
      /**  */
      searchText?: string;
      /** International = 1, National = 2 */
      routeType?: RouteType;
      /**  */
      stationId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-routes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        RouteType: params['routeType'],
        StationId: params['stationId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-entity-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBasicInfo(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteBasicInfoModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-basic-info/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRouteStops(
    params: {
      /**  */
      routeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteStopDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-route-stops/{routeId}';
      url = url.replace('{routeId}', params['routeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: RouteModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: RouteModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: RouteExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: RouteExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/routes/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class RouteLocationService {
  /**
   *
   */
  static getLocations(
    params: {
      /**  */
      name?: string;
      /**  */
      latitude?: number;
      /**  */
      longitude?: number;
      /**  */
      placeId?: string;
      /**  */
      stationId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RouteLocationDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/route-locations/get-locations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Latitude: params['latitude'],
        Longitude: params['longitude'],
        PlaceId: params['placeId'],
        StationId: params['stationId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateRouteLocationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/route-locations/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateRouteLocationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/route-locations/update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/route-locations/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SaleWithGroupReportService {
  /**
   *
   */
  static getReports(
    params: {
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SaleWithGroupReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sale-with-group-reports/get-reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { FromDate: params['fromDate'], ToDate: params['toDate'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: SaleWithGroupReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sale-with-group-reports/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: SaleWithGroupReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sale-with-group-reports/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SeatingModelService {
  /**
   *
   */
  static getSeatingModels(
    params: {
      /**  */
      seatingModelName?: string;
      /** 2X2 (5) = 1, 3X2 (6) = 2, 3X3 (7) = 3, 2X3 (6) = 4 */
      seatingType?: SeatingType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SeatingModelDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-seating-models';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SeatingModelName: params['seatingModelName'],
        SeatingType: params['seatingType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdateSeatingModelModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-entity-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateSeatingModelModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateSeatingModelModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: SeatingModelExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: SeatingModelExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      seatingModelName?: string;
      /** 2X2 (5) = 1, 3X2 (6) = 2, 3X3 (7) = 3, 2X3 (6) = 4 */
      seatingType?: SeatingType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SeatingModelAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SeatingModelName: params['seatingModelName'], SeatingType: params['seatingType'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSeatingModelSummary(
    params: {
      /**  */
      seatingModelId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SeatingModelSummary> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-seating-model-summary/{seatingModelId}';
      url = url.replace('{seatingModelId}', params['seatingModelId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSeats(
    params: {
      /**  */
      seatingModelId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SeatInfo[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/seating-models/get-seats/{seatingModelId}';
      url = url.replace('{seatingModelId}', params['seatingModelId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class SellOnTheGoService {
  /**
   *
   */
  static getBookings(
    params: {
      /**  */
      bookingRefNo?: string;
      /**  */
      receiptRefNo?: string;
      /**  */
      bookingDate?: string;
      /**  */
      departureDate?: string;
      /**  */
      passengerName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoBookingListingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/sell-on-the-go/get-bookings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BookingRefNo: params['bookingRefNo'],
        ReceiptRefNo: params['receiptRefNo'],
        BookingDate: params['bookingDate'],
        DepartureDate: params['departureDate'],
        PassengerName: params['passengerName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBookingDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoBookingDetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/sell-on-the-go/get-booking-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTickets(
    params: {
      /**  */
      tripId?: string;
      /**  */
      sourceId?: string;
      /**  */
      destinationId?: string;
      /**  */
      bookingId?: string;
      /**  */
      bookingRefNo?: string;
      /**  */
      ticketRefNo?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoTicketListingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/sell-on-the-go/get-tickets';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TripId: params['tripId'],
        SourceId: params['sourceId'],
        DestinationId: params['destinationId'],
        BookingId: params['bookingId'],
        BookingRefNo: params['bookingRefNo'],
        TicketRefNo: params['ticketRefNo'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class SellOnTheGoFareConfigurationService {
  /**
   *
   */
  static getFareConfigurations(
    params: {
      /**  */
      tariffParameterName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoFareConfigurationDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/sell-on-the-go-fare-configurations/get-fare-configurations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TariffParameterName: params['tariffParameterName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SellOnTheGoFareConfigurationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/sell-on-the-go-fare-configurations/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SellOnTheGoFareConfigurationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/sell-on-the-go-fare-configurations/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/sell-on-the-go-fare-configurations/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTariffParameters(options: IRequestOptions = {}): Promise<TariffAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/sell-on-the-go-fare-configurations/get-tariff-parameters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class SellOnTheGoReconciliationService {
  /**
   *
   */
  static getEmployeeReconciliationDetails(
    params: {
      /**  */
      employeeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoReconciliationDetailsModel> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/api/bookings/sell-on-the-go-reconciliations/get-employee-reconciliation-details/{employeeId}';
      url = url.replace('{employeeId}', params['employeeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEmployeeReconciliationPaymentRecords(
    params: {
      /**  */
      employeeId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SellOnTheGoReconciliationPaymentDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/sell-on-the-go-reconciliations/get-employee-reconciliation-payment-records';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        EmployeeId: params['employeeId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static logReconciliationRecord(
    params: {
      /** requestBody */
      body?: LogSellOnTheGoReconciliationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/sell-on-the-go-reconciliations/log-reconciliation-record';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ServiceConfigurationService {
  /**
   *
   */
  static getServices(
    params: {
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceConfigurationDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/get-services';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutoCompletion(options: IRequestOptions = {}): Promise<ServiceAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/get-auto-completion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateServiceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateServiceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateUpdateServiceModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/get-entity-for-update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/services/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ShipmentCancellationPolicySettingService {
  /**
   *
   */
  static getSettings(options: IRequestOptions = {}): Promise<ShipmentCancellationPolicySettingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-cancellation-policy-settings/get-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ShipmentCancellationPolicySettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-cancellation-policy-settings/update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ShipmentReconciliationService {
  /**
   *
   */
  static getRegisterPaymentRecords(
    params: {
      /**  */
      registerId?: string;
      /**  */
      shipmentRefNo?: string;
      /**  */
      receiptRefNo?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterShipmentPaymentModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipment-reconciliations/get-register-payment-records';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RegisterId: params['registerId'],
        ShipmentRefNo: params['shipmentRefNo'],
        ReceiptRefNo: params['receiptRefNo'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class ShipmentTariffService {
  /**
   *
   */
  static getShipmentTariffs(
    params: {
      /**  */
      sourceId?: string;
      /**  */
      destinationId?: string;
      /**  */
      boxWeightId?: string;
      /**  */
      boxVolumeId?: string;
      /**  */
      boxCategoryId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShipmentTariffPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/get-shipment-tariffs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SourceId: params['sourceId'],
        DestinationId: params['destinationId'],
        BoxWeightId: params['boxWeightId'],
        BoxVolumeId: params['boxVolumeId'],
        BoxCategoryId: params['boxCategoryId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateShipmentTariffModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateShipmentTariffModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static downloadImportFileTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/download-import-file-template';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      fileName?: string;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseImportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/shipments/shipment-tariffs/import';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);
      configs.params = { FileName: params['fileName'] };

      let data = null;
      data = new FormData();
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SmsService {
  /**
   *
   */
  static getSmsMessages(
    params: {
      /** CompanySmsService = 1, Twilio = 2 */
      smsProvider?: SmsProvider;
      /**  */
      countryCode?: string;
      /**  */
      phoneNumber?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SmsMessagePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms/get-sms-messages';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SmsProvider: params['smsProvider'],
        CountryCode: params['countryCode'],
        PhoneNumber: params['phoneNumber'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class SmsTemplateService {
  /**
   *
   */
  static getSmsTemplates(
    params: {
      /**  */
      name?: string;
      /**  */
      cultureCode?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SmsTemplateDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms-templates/get-sms-templates';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        CultureCode: params['cultureCode'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSmsNames(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms-templates/get-sms-names';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SmsTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms-templates/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SmsTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms-templates/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/notifications/sms-templates/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SoftwareComponentService {
  /**
   *
   */
  static getSoftwareComponentsForUpdate(options: IRequestOptions = {}): Promise<UpdateSoftwareComponentModelDetail[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/get-software-components-for-update';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getActiveSoftwareComponents(
    params: {
      /**  */
      availableApps?: SystemApp[];
      /** Basic = 1, Optional = 2 */
      componentType?: SoftwareComponentType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SoftwareComponentDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/get-active-software-components';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { AvailableApps: params['availableApps'], ComponentType: params['componentType'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateSoftwareComponents(
    params: {
      /** requestBody */
      body?: UpdateSoftwareComponentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/update-software-components';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: SoftwareComponentExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: SoftwareComponentExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/software-components/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class StationService {
  /**
   *
   */
  static getStations(
    params: {
      /**  */
      name?: string;
      /**  */
      stationCode?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationModelPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/get-stations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        StationCode: params['stationCode'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateStationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateStationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateStationBalance(
    params: {
      /** requestBody */
      body?: UpdateStationBalanceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/update-station-balance';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentStationBalance(
    params: {
      /**  */
      stationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationCurrentBalanceModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/get-current-station-balance/{stationId}';
      url = url.replace('{stationId}', params['stationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static balanceProof(
    params: {
      /**  */
      activityId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/balance-proof/{activityId}';
      url = url.replace('{activityId}', params['activityId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStationBalanceLogs(
    params: {
      /**  */
      stationId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationBalanceDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/get-station-balance-logs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StationId: params['stationId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      name?: string;
      /**  */
      limit: number;
      /**  */
      countryIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/stations/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Name: params['name'], Limit: params['limit'], CountryIds: params['countryIds'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class StationPrinterService {
  /**
   *
   */
  static getStationPrinters(
    params: {
      /**  */
      stationId?: string;
      /** EPSON_LAN = 1, BIXOLON_USB = 2 */
      printerCompany?: PrinterCompany;
      /** Receipts = 1, Tags = 2 */
      printType?: PrintType;
      /**  */
      deviceName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationPrinterDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/get-station-printers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StationId: params['stationId'],
        PrinterCompany: params['printerCompany'],
        PrintType: params['printType'],
        DeviceName: params['deviceName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStationPrintersByStation(
    params: {
      /**  */
      stationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationPrinterInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/get-station-printers-by-station/{stationId}';
      url = url.replace('{stationId}', params['stationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStationPrintersByRegister(
    params: {
      /**  */
      registerId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StationPrinterInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/get-station-printers-by-register/{registerId}';
      url = url.replace('{registerId}', params['registerId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: StationPrinterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: StationPrinterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/station-printers/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SupervisorPinService {
  /**
   *
   */
  static supervisorPin(options: IRequestOptions = {}): Promise<SupervisorPinStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/supervisor-pin';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static supervisorPin1(
    params: {
      /** requestBody */
      body?: SetSupervisorPinRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/supervisor-pin';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TariffAgeIssueService {
  /**
   *
   */
  static tariffAgeIssues(
    params: {
      /**  */
      includeReviewed?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TariffAgeIssueModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/tariff-age-issues';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { includeReviewed: params['includeReviewed'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reviewed(
    params: {
      /**  */
      source: TariffAgeIssueSource;
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/tariff-age-issues/{source}/{ticketId}/reviewed';
      url = url.replace('{source}', params['source'] + '');
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TariffParameterService {
  /**
   *
   */
  static getTariffParameters(
    params: {
      /**  */
      searchText?: string;
      /**  */
      isStandard?: boolean;
      /**  */
      isActive?: boolean;
      /** Person = 1, Age = 2, Profession = 3, PhysicalConditions = 4, Special = 5, TicketConditions = 6, CarteLoyalty = 7, Partner = 8, Regularisation = 9 */
      category?: TariffCategory;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TariffParameterDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/get-tariff-parameters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        IsStandard: params['isStandard'],
        IsActive: params['isActive'],
        Category: params['category'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(options: IRequestOptions = {}): Promise<TariffAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TariffParameterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TariffParameterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTariffParametersByCategory(
    params: {
      /**  */
      isTicketCondition: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TariffParameterBasicInfo[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/tariff-parameters/get-tariff-parameters-by-category/{isTicketCondition}';
      url = url.replace('{isTicketCondition}', params['isTicketCondition'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyTariffParametersByCategory(
    params: {
      /**  */
      companyId: string;
      /**  */
      isTicketCondition: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TariffParameterBasicInfo[]> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/api/fleets/tariff-parameters/get-company-tariff-parameters-by-category/{companyId}/{isTicketCondition}';
      url = url.replace('{companyId}', params['companyId'] + '');
      url = url.replace('{isTicketCondition}', params['isTicketCondition'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TerminalService {
  /**
   *
   */
  static terminals(options: IRequestOptions = {}): Promise<TerminalModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terminals';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static terminals1(
    params: {
      /** requestBody */
      body?: CreateTerminalRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TerminalEnrollmentCodeResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terminals';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static enrollmentCode(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TerminalEnrollmentCodeResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terminals/{id}/enrollment-code';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static revoke(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: RevokeTerminalRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TerminalResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terminals/{id}/revoke';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketCancellationPolicySettingModelService {
  /**
   *
   */
  static getTicketCancellationPolicySettings(
    params: {
      /**  */
      ticketConditionId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketCancellationPolicySettingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-policy-settings/get-ticket-cancellation-policy-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TicketConditionId: params['ticketConditionId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketCancellationPolicySettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-policy-settings/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketCancellationPolicySettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-policy-settings/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-policy-settings/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketCancellationRequestService {
  /**
   *
   */
  static pending(options: IRequestOptions = {}): Promise<TicketCancellationRequestDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-requests/pending';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static approve(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: ReviewTicketCancellationRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-requests/approve/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reject(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: ReviewTicketCancellationRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-cancellation-requests/reject/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketClassService {
  /**
   *
   */
  static getTicketClasses(
    params: {
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseTicketClassDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/ticket-classes/get-ticket-classes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      name?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketClassAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/ticket-classes/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Name: params['name'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketClassModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/ticket-classes/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketClassModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/ticket-classes/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/ticket-classes/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketConflictManagementService {
  /**
   *
   */
  static getConflictTickets(
    params: {
      /**  */
      bookingRefNo?: string;
      /**  */
      ticketRefNo?: string;
      /**  */
      tripCode?: string;
      /** Issued = 1, CheckedIn = 2, Cancelled = 3, Pending = 4, Expired = 5, UnUsed = 6, Boarded = 7, Waiting = 8, Free = 9, CancelRequested = 10, Replaced = 11 */
      ticketStatus?: TicketStatus;
      /**  */
      passengerName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketConflictListingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-conflict-management/get-conflict-tickets';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BookingRefNo: params['bookingRefNo'],
        TicketRefNo: params['ticketRefNo'],
        TripCode: params['tripCode'],
        TicketStatus: params['ticketStatus'],
        PassengerName: params['passengerName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTicketDetails(
    params: {
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BookingTicketDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-conflict-management/get-ticket-details/{ticketId}';
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripDetails(
    params: {
      /**  */
      bookingTripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConflictTripDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-conflict-management/get-trip-details/{bookingTripId}';
      url = url.replace('{bookingTripId}', params['bookingTripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: TicketConflictExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-conflict-management/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: TicketConflictExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-conflict-management/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketModificationPolicyService {
  /**
   *
   */
  static ticketModificationPolicy(options: IRequestOptions = {}): Promise<TicketModificationPolicyModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static ticketModificationPolicy1(
    params: {
      /** requestBody */
      body?: TicketModificationPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketModificationPolicyModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-policy';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static history(
    params: {
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketModificationHistoryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modifications/{ticketId}/history';
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TicketModificationSettingService {
  /**
   *
   */
  static getTicketModificationSettings(
    params: {
      /**  */
      ticketConditionId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketModificationPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-settings/get-ticket-modification-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TicketConditionId: params['ticketConditionId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketModificationSettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-settings/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateTicketModificationSettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-settings/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-modification-settings/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TicketReprintService {
  /**
   *
   */
  static ticketReprints(
    params: {
      /**  */
      ticketId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TicketReprintHistoryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bookings/ticket-reprints/{ticketId}';
      url = url.replace('{ticketId}', params['ticketId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TransportImportHistoryService {
  /**
   *
   */
  static insert(
    params: {
      /** requestBody */
      body?: CreateTransportImportHistoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/import-histories/insert';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getImportHistories(
    params: {
      /**  */
      importType?: ImportType;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportImportHistoryPagingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/import-histories/get-import-histories';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ImportType: params['importType'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static log(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/import-histories/{id}/log';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TransportTicketSettingService {
  /**
   *
   */
  static getTransportTicketSettings(
    params: {
      /**  */
      countryId?: string;
      /**  */
      companyDisplayName?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportTicketSettingDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/transport-ticket-settings/get-transport-ticket-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CountryId: params['countryId'],
        CompanyDisplayName: params['companyDisplayName'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTransportTicketSettingsByCountries(
    params: {
      /**  */
      countryIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportTicketSettingDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/transport-ticket-settings/get-transport-ticket-settings-by-countries';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { countryIds: params['countryIds'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TransportTicketSettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/transport-ticket-settings/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TransportTicketSettingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/transport-ticket-settings/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/transport-ticket-settings/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TransportVendorService {
  /**
   *
   */
  static getTransportVendors(
    params: {
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportVendorDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/transport-vendors/get-transport-vendors';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TransportVendorModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/transport-vendors/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TransportVendorModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/transport-vendors/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/transport-vendors/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TransportVendorAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/transport-vendors/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TripService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TripModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static duplicateTrip(
    params: {
      /** requestBody */
      body?: DuplicateTripModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/duplicate-trip';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static searchTrips(
    params: {
      /**  */
      sourceStationId?: string;
      /**  */
      destinationStationId?: string;
      /**  */
      departureDate?: string;
      /**  */
      ticketClass?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripSearchResponsePagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/search-trips';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SourceStationId: params['sourceStationId'],
        DestinationStationId: params['destinationStationId'],
        DepartureDate: params['departureDate'],
        TicketClass: params['ticketClass'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrips(
    params: {
      /**  */
      searchText?: string;
      /**  */
      routeId?: string;
      /**  */
      departureDate?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-trips';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        RouteId: params['routeId'],
        DepartureDate: params['departureDate'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      limit?: number;
      /**  */
      routeId?: string;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Limit: params['limit'], RouteId: params['routeId'], SearchText: params['searchText'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSegmentAutocompletionList(
    params: {
      /**  */
      routeId?: string;
      /**  */
      baseTripId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SegmentAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-segment-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { RouteId: params['routeId'], BaseTripId: params['baseTripId'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCalendarTrips(
    params: {
      /**  */
      countryId?: string;
      /**  */
      sourceStationId?: string;
      /**  */
      fromDate?: string;
      /**  */
      toDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CalendarTripModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-calendar-trips';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CountryId: params['countryId'],
        SourceStationId: params['sourceStationId'],
        FromDate: params['fromDate'],
        ToDate: params['toDate']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetails(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-details/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: TripExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: TripExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static considerSearch(
    params: {
      /**  */
      id: string;
      /**  */
      allowSearch: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trips/consider-search/{id}/{allowSearch}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{allowSearch}', params['allowSearch'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TripDetailService {
  /**
   *
   */
  static getTripDetails(
    params: {
      /**  */
      searchText?: string;
      /**  */
      departureDate: string;
      /**  */
      routeId?: string;
      /**  */
      sourceStationId?: string;
      /**  */
      destinationStationId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripDetailDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-trip-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        DepartureDate: params['departureDate'],
        RouteId: params['routeId'],
        SourceStationId: params['sourceStationId'],
        DestinationStationId: params['destinationStationId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCalendarTripDetails(
    params: {
      /**  */
      departureDate?: string;
      /**  */
      stationId?: string;
      /**  */
      includePassingStation?: boolean;
      /**  */
      routeId?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripDetailCalendarDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-calendar-trip-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DepartureDate: params['departureDate'],
        StationId: params['stationId'],
        IncludePassingStation: params['includePassingStation'],
        RouteId: params['routeId'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityForUpdate(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-entity-for-update/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripAssignment(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripAssignmentModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-trip-assignment/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateTripAssignment(
    params: {
      /** requestBody */
      body?: UpdateTripAssignmentModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/update-trip-assignment';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentStation(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CurrentTripStationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-current-station/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateTripStatus(
    params: {
      /** requestBody */
      body?: UpdateTripStatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/update-trip-status';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateTripDetail(
    params: {
      /** requestBody */
      body?: UpdateTripDetailModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/update-trip-detail';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripBusAssignment(
    params: {
      /**  */
      tripIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripBusDetailsModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-trip-bus-assignment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { tripIds: params['tripIds'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripStatus(
    params: {
      /**  */
      tripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/get-trip-status/{tripId}';
      url = url.replace('{tripId}', params['tripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportTravelerReportPdf(
    params: {
      /** requestBody */
      body?: TripTravelerPdfReportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/export-traveler-report-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendTravelerReportByEmail(
    params: {
      /** requestBody */
      body?: TripTravelerReportEmailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-details/send-traveler-report-by-email';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TripGroupService {
  /**
   *
   */
  static getAutocompletionList(
    params: {
      /**  */
      name?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripGroupAutocompletionModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-groups/get-autocompletion-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Name: params['name'] };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TripGroupModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-groups/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TripLocationService {
  /**
   *
   */
  static updateTripLocations(
    params: {
      /** requestBody */
      body?: CreateUpdateTripLocationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/update-trip-locations';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripLocations(
    params: {
      /**  */
      baseTripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetTripLocationsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/get-trip-locations/{baseTripId}';
      url = url.replace('{baseTripId}', params['baseTripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripDirections(
    params: {
      /**  */
      baseTripId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetTripDirectionResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/get-trip-directions/{baseTripId}';
      url = url.replace('{baseTripId}', params['baseTripId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripDetailsLocations(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetTripLocationsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/get-trip-details-locations/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripDetailsDirections(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetTripDirectionResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/get-trip-details-directions/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripCurrentLocation(
    params: {
      /**  */
      tripDetailId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripCurrentLocationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-locations/get-trip-current-location/{tripDetailId}';
      url = url.replace('{tripDetailId}', params['tripDetailId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class TripSearchService {
  /**
   *
   */
  static searchBasicTripAvailable(
    params: {
      /** requestBody */
      body?: BasicTripAvailableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BasicTripAvailableModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/search-basic-trip-available';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static searchTripAvailable(
    params: {
      /** requestBody */
      body?: TripAvailableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripAvailableResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/search-trip-available';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTripSeatingModel(
    params: {
      /** requestBody */
      body?: GetTripSeatingModelRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripSeatingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/get-trip-seating-model';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailableTripDetails(
    params: {
      /** requestBody */
      body?: AvailableTripDetailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AvailableTripDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/get-available-trip-details';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailableTripSegments(
    params: {
      /** requestBody */
      body?: AvailableTripSegmentRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AvailableTripSegmentModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/get-available-trip-segments';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailableTripTariffs(
    params: {
      /** requestBody */
      body?: GlobalAvailableTripTariffRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AvailableTripTariffModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/fleets/trip-search/get-available-trip-tariffs';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TripStatusReportService {
  /**
   *
   */
  static getReports(
    params: {
      /**  */
      isDeparture: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TripStatusReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/trip-status-reports/get-reports/{isDeparture}';
      url = url.replace('{isDeparture}', params['isDeparture'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   *
   */
  static currentUser(options: IRequestOptions = {}): Promise<CurrentUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/current-user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateRoles(
    params: {
      /** requestBody */
      body?: UpdateRolesModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/update-roles';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateProfile(
    params: {
      /** requestBody */
      body?: UpdateUserProfileModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/update-profile';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static language(
    params: {
      /**  */
      language: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/language/{language}';
      url = url.replace('{language}', params['language'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cashierForgotPassword(
    params: {
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/cashier-forgot-password/{email}';
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static forgotPassword(
    params: {
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/forgot-password/{email}';
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ForgotPasswordModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/reset-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static confirmEmail(
    params: {
      /** requestBody */
      body?: ConfirmEmailModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/confirm-email';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static checkResetPasswordToken(
    params: {
      /**  */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/check-reset-password-token/{token}';
      url = url.replace('{token}', params['token'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changePassword(
    params: {
      /** requestBody */
      body?: ChangePasswordModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BaseResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user-accounts/users/change-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UtilityPartnerService {
  /**
   *
   */
  static getUtilityPartners(
    params: {
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UtilityPartnerDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/get-utility-partners';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateUtilityPartnerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateUtilityPartnerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UtilityPartnerDetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExportColumns(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/get-export-columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: UtilityPartnerExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/export-excel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportPdf(
    params: {
      /** requestBody */
      body?: UtilityPartnerExportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partners/export-pdf';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UtilityPartnerConnectivityService {
  /**
   *
   */
  static getUtilityPartnerConnectivityList(
    params: {
      /**  */
      utilityPartnerId?: string;
      /**  */
      ipAddress?: string;
      /**  */
      searchText?: string;
      /**  */
      pageIndex?: number;
      /**  */
      pageSize?: number;
      /**  */
      orderBy?: string;
      /**  */
      orderByAsc?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UtilityPartnerConnectivityDtoPagingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partner-connectivity/get-utility-partner-connectivity-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UtilityPartnerId: params['utilityPartnerId'],
        IpAddress: params['ipAddress'],
        SearchText: params['searchText'],
        PageIndex: params['pageIndex'],
        PageSize: params['pageSize'],
        OrderBy: params['orderBy'],
        OrderByAsc: params['orderByAsc']
      };

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUpdateUtilityPartnerConnectivityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partner-connectivity/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateUpdateUtilityPartnerConnectivityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partner-connectivity/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UtilityPartnerConnectivityDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partner-connectivity/get-detail/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配ios13，get请求不允许带body */

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuidBaseUpdateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/commons/utility-partner-connectivity/delete/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export interface AccessRequirementDto {
  /**  */
  userType?: UserType;

  /**  */
  twoFactorEnabled?: boolean;
}

export interface ActiveInactivePartnerAccountModel {
  /**  */
  id?: string;

  /**  */
  isActive?: boolean;
}

export interface ActiveTicketSellingModel {
  /**  */
  id?: string;

  /**  */
  isTicketSellingEnabled?: boolean;
}

export interface AdvertisingTripAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  tripName?: string;

  /**  */
  tripRefNo?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationName?: string;
}

export interface AuthenticatorCodeModel {
  /**  */
  code?: string;
}

export interface AuthenticatorRecoveryCodesModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  recoveryCodes?: string[];
}

export interface AuthenticatorSetupModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  sharedKey?: string;

  /**  */
  authenticatorUri?: string;

  /**  */
  qrCodeSvg?: string;
}

export interface AuthenticatorStatusModel {
  /**  */
  enrolled?: boolean;

  /**  */
  recoveryCodesLeft?: number;
}

export interface AvailableSeatModel {
  /**  */
  id?: string;

  /**  */
  row?: number;

  /**  */
  column?: number;

  /**  */
  type?: BusEntityType;

  /**  */
  ticketClassId?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  seatColor?: string;

  /**  */
  name?: string;

  /**  */
  bookedSourceId?: string;

  /**  */
  bookedDestinationId?: string;

  /**  */
  status?: SeatStatus;
}

export interface AvailableTripDetailModel {
  /**  */
  tripId?: string;

  /**  */
  companyId?: string;

  /**  */
  tripName?: string;

  /**  */
  noOfStops?: number;

  /**  */
  sourceStationName?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  recurrenceNumDays?: number[];

  /**  */
  availableSeats?: number;

  /**  */
  busName?: string;

  /**  */
  tripStatus?: TripStatus;

  /**  */
  busBrand?: string;

  /**  */
  busPlateNumber?: string;

  /**  */
  driver?: string;

  /**  */
  coDriver?: string;

  /**  */
  totalSeats?: number;
}

export interface AvailableTripDetailRequest {
  /**  */
  tripId?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationStationId?: string;
}

export interface AvailableTripSegmentModel {
  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;

  /**  */
  sourceStationName?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  distance?: number;

  /**  */
  baseTicketTariff?: number;

  /**  */
  baggageTariff?: number;
}

export interface AvailableTripSegmentRequest {
  /**  */
  tripId?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationStationId?: string;
}

export interface AvailableTripTariffModel {
  /**  */
  companyId?: string;

  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;

  /**  */
  tariffParameterId?: string;

  /**  */
  ticketClassId?: string;

  /**  */
  direction?: SegmentTariffParameterDirection;

  /**  */
  diffAmount?: number;

  /**  */
  amount?: number;

  /**  */
  returnDiffAmount?: number;

  /**  */
  returnAmount?: number;
}

export interface BaggageReconciliationDetailsModel {
  /**  */
  companyUserId?: string;

  /**  */
  userName?: string;

  /**  */
  companyUserFullName?: string;

  /**  */
  lastReconciliationDate?: Date;

  /**  */
  totalAmount?: number;

  /**  */
  allowReconciliation?: boolean;
}

export interface BaggageReconciliationPaymentDto {
  /**  */
  bookingId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  tripName?: string;

  /**  */
  bookingDate?: Date;

  /**  */
  paymentDate?: Date;

  /**  */
  amount?: number;
}

export interface BaggageReconciliationPaymentDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BaggageReconciliationPaymentDto[];
}

export interface BaggageTariffDto {
  /**  */
  id?: string;

  /**  */
  segmentId?: string;

  /**  */
  originStationId?: string;

  /**  */
  originStationName?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  baseTicketClassId?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  freeBags?: number;

  /**  */
  standardTariff?: number;

  /**  */
  maxBagsAllowed?: number;

  /**  */
  secondTariff?: number;

  /**  */
  bikeTariff?: number;
}

export interface BaggageTariffDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BaggageTariffDto[];
}

export interface BaggageTariffExportRequest {
  /**  */
  companyTicketClassId?: string;

  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface BaseImportColumn {
  /**  */
  columnName?: string;

  /**  */
  isRequired?: boolean;
}

export interface BaseImportResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  totalRecords?: number;

  /**  */
  insertedRecords?: number;

  /**  */
  invalidRecords?: number;

  /**  */
  logUrl?: string;
}

export interface BaseResponseModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;
}

export interface BaseTariffParameterDto {
  /**  */
  id?: string;

  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  isStandard?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  category?: TariffCategory;

  /**  */
  passengerType?: PassengerType;
}

export interface BaseTariffParameterDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BaseTariffParameterDto[];
}

export interface BaseTicketClassDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  seatColor?: string;

  /**  */
  isStandard?: boolean;
}

export interface BaseTicketClassDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BaseTicketClassDto[];
}

export interface BasicBookingInfoModel {
  /**  */
  id?: string;

  /**  */
  bookingDate?: Date;

  /**  */
  bookingRefNo?: string;

  /**  */
  journeyType?: JourneyType;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  departureTripNo?: string;

  /**  */
  departureTripName?: string;

  /**  */
  returnDepartureDateTime?: Date;

  /**  */
  returnArrivalDateTime?: Date;

  /**  */
  returnTripNo?: string;

  /**  */
  returnTripName?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  ticketConditionName?: string;
}

export interface BasicTariffDto {
  /**  */
  id?: string;

  /**  */
  segmentId?: string;

  /**  */
  originStationId?: string;

  /**  */
  originStationName?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  amount?: number;

  /**  */
  returnAmount?: number;

  /**  */
  baseTicketClassId?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  distance?: number;
}

export interface BasicTariffDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BasicTariffDto[];
}

export interface BasicTariffExportRequest {
  /**  */
  baseTicketClassId?: string;

  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface BasicTripAvailableModel {
  /**  */
  tripId?: string;

  /**  */
  tripName?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  sourceStationName?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  companyName?: string;

  /**  */
  companyLogoUrl?: string;
}

export interface BasicTripAvailableRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  departureDate?: Date;

  /**  */
  departureTimeFrom?: string;

  /**  */
  departureTimeTo?: string;
}

export interface BlockUnBlockCompanyModel {
  /**  */
  id?: string;

  /**  */
  isActive?: boolean;
}

export interface BookingDetailsModel {
  /**  */
  id?: string;

  /**  */
  bookingDate?: Date;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  journeyType?: JourneyType;

  /**  */
  tripBoardingLimitTime?: number;

  /**  */
  sourceStation?: string;

  /**  */
  sourceCountry?: string;

  /**  */
  destinationStation?: string;

  /**  */
  destinationCountry?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  duration?: number;

  /**  */
  departureTripNo?: string;

  /**  */
  departureTripName?: string;

  /**  */
  returnDepartureDateTime?: Date;

  /**  */
  returnArrivalDateTime?: Date;

  /**  */
  returnDuration?: number;

  /**  */
  returnTripNo?: string;

  /**  */
  returnTripName?: string;

  /**  */
  netAmount?: number;

  /**  */
  discountAmount?: number;

  /**  */
  totalAmount?: number;

  /**  */
  status?: BookingStatus;

  /**  */
  tickets?: BookingTicketDetailsModel[];

  /**  */
  paymentRecords?: BookingPaymentDetails[];
}

export interface BookingHistoryDto {
  /**  */
  id?: string;

  /**  */
  bookingId?: string;

  /**  */
  entityId?: string;

  /**  */
  comments?: string;

  /**  */
  changeValues?: ChangeValue[];

  /**  */
  changeDate?: Date;

  /**  */
  actorId?: string;

  /**  */
  actor?: string;
}

export interface BookingHistoryDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BookingHistoryDto[];
}

export interface BookingPagingDto {
  /**  */
  bookingId?: string;

  /**  */
  onlineBookingId?: string;

  /**  */
  registerId?: string;

  /**  */
  registerName?: string;

  /**  */
  cashierId?: string;

  /**  */
  cashierName?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  sourceCityName?: string;

  /**  */
  destinationCityName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  tripNames?: string[];

  /**  */
  ticketConditions?: string[];

  /**  */
  ticketClasses?: string[];

  /**  */
  journeyType?: JourneyType;

  /**  */
  bookingDate?: Date;
}

export interface BookingPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BookingPagingDto[];
}

export interface BookingPaymentDetails {
  /**  */
  payMode?: BookingPayMode;

  /**  */
  totalAmount?: number;

  /**  */
  cashChange?: number;

  /**  */
  cashTendered?: number;

  /**  */
  transactionId?: string;

  /**  */
  approvalCode?: string;

  /**  */
  transactionMessage?: string;

  /**  */
  paymentDateTime?: Date;
}

export interface BookingSeatDetailsModel {
  /**  */
  bookingMapId?: string;

  /**  */
  tripDetailId?: string;

  /**  */
  tripCode?: string;

  /**  */
  tripName?: string;

  /**  */
  tripRouteType?: TripRouteType;

  /**  */
  seatingModelName?: string;

  /**  */
  seatingModelType?: SeatingType;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  sequenceNumber?: number;

  /**  */
  status?: TicketStatus;

  /**  */
  busName?: string;

  /**  */
  busNumber?: string;
}

export interface BookingTariffParameter {
  /**  */
  tariffParameterId?: string;

  /**  */
  ticketCount?: number;
}

export interface BookingTicketDetailsModel {
  /**  */
  ticketId?: string;

  /**  */
  isMainPassenger?: boolean;

  /**  */
  tariffParameterName?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  ticketAmount?: number;

  /**  */
  sequence?: number;

  /**  */
  status?: TicketStatus;

  /**  */
  passengerFirstName?: string;

  /**  */
  passengerLastName?: string;

  /**  */
  seats?: BookingSeatDetailsModel[];
}

export interface BoxCategoryAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxCategoryPagingDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  boxTypeId?: string;

  /**  */
  boxTypeName?: string;
}

export interface BoxCategoryPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BoxCategoryPagingDto[];
}

export interface BoxTypeAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxTypePagingDto {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxTypePagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BoxTypePagingDto[];
}

export interface BoxVolumeAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxVolumePagingDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  value?: number;
}

export interface BoxVolumePagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BoxVolumePagingDto[];
}

export interface BoxWeightAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxWeightPagingDto {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BoxWeightPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BoxWeightPagingDto[];
}

export interface BusAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  busRefNo?: string;

  /**  */
  busBrand?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  plateNumber?: string;

  /**  */
  serialNo?: string;
}

export interface BusBrandAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  brandName?: string;

  /**  */
  brandSymbol?: string;
}

export interface BusBrandDto {
  /**  */
  id?: string;

  /**  */
  brandName?: string;

  /**  */
  brandSymbol?: string;

  /**  */
  brandCountry?: string;
}

export interface BusBrandDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusBrandDto[];
}

export interface BusDocumentDto {
  /**  */
  id?: string;

  /**  */
  fileName?: string;

  /**  */
  fileUrl?: string;

  /**  */
  busId?: string;

  /**  */
  busName?: string;
}

export interface BusDocumentDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusDocumentDto[];
}

export interface BusDto {
  /**  */
  id?: string;

  /**  */
  busRefNo?: string;

  /**  */
  busName?: string;

  /**  */
  serialNo?: string;

  /**  */
  chassisNo?: string;

  /**  */
  motorPower?: string;

  /**  */
  acquisitionDate?: Date;

  /**  */
  baggageCapacity?: string;

  /**  */
  initialColor?: string;

  /**  */
  plateNumber?: string;

  /**  */
  transportVendorId?: string;

  /**  */
  transportVendorName?: string;

  /**  */
  purchaseOrderDetailId?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  seatingModelName?: string;

  /**  */
  busModelId?: string;

  /**  */
  busModelName?: string;

  /**  */
  busBrandId?: string;

  /**  */
  busBrandName?: string;
}

export interface BusDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusDto[];
}

export interface BusEntitySummary {
  /**  */
  type?: BusEntityType;

  /**  */
  count?: number;
}

export interface BusExportRequest {
  /**  */
  busName?: string;

  /**  */
  plateNumber?: string;

  /**  */
  serialNo?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  modelId?: string;

  /**  */
  brandId?: string;

  /**  */
  columns: string[];
}

export interface BusInsuranceDto {
  /**  */
  id?: string;

  /**  */
  startDate?: Date;

  /**  */
  expiryDate?: Date;

  /**  */
  policyNumber?: string;

  /**  */
  busInsurerId?: string;

  /**  */
  insurerName?: string;

  /**  */
  busId?: string;

  /**  */
  busName?: string;

  /**  */
  status?: BusInsuranceStatus;
}

export interface BusInsuranceDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusInsuranceDto[];
}

export interface BusInsurerAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface BusInsurerDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  phone?: string;
}

export interface BusInsurerDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusInsurerDto[];
}

export interface BusModelAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  busModelName?: string;
}

export interface BusModelDto {
  /**  */
  id?: string;

  /**  */
  modelName?: string;

  /**  */
  busBrandId?: string;

  /**  */
  busBrandName?: string;

  /**  */
  modelPower?: string;

  /**  */
  modelYear?: string;
}

export interface BusModelDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusModelDto[];
}

export interface BusStationMappingDto {
  /**  */
  id?: string;

  /**  */
  busId?: string;

  /**  */
  busName?: string;

  /**  */
  stationId?: string;

  /**  */
  stationName?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;
}

export interface BusStationMappingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusStationMappingDto[];
}

export interface BusStationMappingModel {
  /**  */
  id?: string;

  /**  */
  busId?: string;

  /**  */
  stationId?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;
}

export interface BusStatusHistoryModel {
  /**  */
  id?: string;

  /**  */
  statusName?: string;

  /**  */
  busStatusId?: string;

  /**  */
  busId?: string;

  /**  */
  busName?: string;

  /**  */
  statusDateTime?: Date;

  /**  */
  statusStation?: string;

  /**  */
  statusComment?: string;
}

export interface BusStatusHistoryModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusStatusHistoryModel[];
}

export interface BusStatusModel {
  /**  */
  id?: string;

  /**  */
  statusName?: string;
}

export interface BusStatusModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: BusStatusModel[];
}

export interface CalendarTripDetailModel {
  /**  */
  baseTripId?: string;

  /**  */
  tripName?: string;

  /**  */
  departureDatetime?: Date;

  /**  */
  arrivalDatetime?: Date;
}

export interface CalendarTripModel {
  /**  */
  date?: Date;

  /**  */
  trips?: CalendarTripDetailModel[];
}

export interface CancellationPolicyPlan {
  /**  */
  hours?: number;

  /**  */
  amount?: number;
}

export interface CashierRegisterModel {
  /**  */
  registerId?: string;

  /**  */
  registerName?: string;

  /**  */
  registerStatus?: RegisterStatus;

  /**  */
  stationId?: string;

  /**  */
  stationName?: string;
}

export interface ChangePasswordModel {
  /**  */
  oldPassword?: string;

  /**  */
  password?: string;
}

export interface ChangeValue {
  /**  */
  propertyName?: string;

  /**  */
  oldValue?: string;

  /**  */
  newValue?: string;
}

export interface CityModel {
  /**  */
  id?: string;

  /**  */
  cityCode?: string;

  /**  */
  cityName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  countryName?: string;

  /**  */
  countryId?: string;
}

export interface CityModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CityModel[];
}

export interface CompanyAccountAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  accountOwner?: string;

  /**  */
  accountNumber?: string;
}

export interface CompanyAccountDto {
  /**  */
  id?: string;

  /**  */
  paymentPartnerId?: string;

  /**  */
  paymentPartnerName?: string;

  /**  */
  paymentPartnerType?: PaymentPartnerType;

  /**  */
  accountOwner?: string;

  /**  */
  accountNumber?: string;

  /**  */
  accountType?: CompanyAccountType;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  isActive?: boolean;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface CompanyAccountDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyAccountDto[];
}

export interface CompanyAutoCompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface CompanyBasicInfo {
  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  phoneNo?: string;

  /**  */
  companyImageUrl?: string;

  /**  */
  phoneCode?: string;
}

export interface CompanyDailyPassengerReportDetail {
  /**  */
  date?: Date;

  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  noOfInfant?: number;
}

export interface CompanyDailyRevenueReportDetail {
  /**  */
  date?: Date;

  /**  */
  value?: number;
}

export interface CompanyDailyTicketReportDetail {
  /**  */
  date?: Date;

  /**  */
  cashierTicketAmount?: number;

  /**  */
  noOfCashierTickets?: number;

  /**  */
  onlineTicketAmount?: number;

  /**  */
  noOfOnlineTickets?: number;
}

export interface CompanyDashboardReportModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  summaryReport?: CompanyDashboardSummaryReportModel;

  /**  */
  ticketBookingReport?: TicketBookingReportModel;

  /**  */
  passengerReport?: PassengerReportModel;

  /**  */
  revenueReport?: CompanyRevenueReportModel;
}

export interface CompanyDashboardSummaryReportModel {
  /**  */
  revenue?: number;

  /**  */
  ticketAmount?: number;

  /**  */
  shipmentAmount?: number;

  /**  */
  expense?: number;

  /**  */
  noOfTicketSold?: number;

  /**  */
  noOfOnlineTickets?: number;

  /**  */
  noOfCashierTickets?: number;

  /**  */
  noOfShipments?: number;

  /**  */
  noOfBaggage?: number;
}

export interface CompanyExportRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface CompanyForUpdateDto {
  /**  */
  id?: string;

  /**  */
  address?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  isActive?: boolean;

  /**  */
  isSmsNotificationAllowed?: boolean;

  /**  */
  planId?: string;
}

export interface CompanyModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNo?: string;

  /**  */
  noOfStations?: string;

  /**  */
  companyImageUrl?: string;

  /**  */
  isCompanySecretKeySet?: boolean;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  ownerId?: string;

  /**  */
  clientId?: string;

  /**  */
  plan?: string;

  /**  */
  noCc?: string;

  /**  */
  noIfu?: string;

  /**  */
  companyWebsiteUrl?: string;

  /**  */
  employerNo?: string;

  /**  */
  orangeBfuSerId?: string;

  /**  */
  isOrangeBfPasswordSet?: boolean;

  /**  */
  isEmailNotificationAllowed?: boolean;

  /**  */
  isSmsNotificationAllowed?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  isApproved?: boolean;
}

export interface CompanyModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyModel[];
}

export interface CompanyMonthlyPassengerReportDetail {
  /**  */
  month?: number;

  /**  */
  noOfAdult?: number;

  /**  */
  noOfChild?: number;

  /**  */
  noOfInfant?: number;
}

export interface CompanyMonthlyRevenueReportDetail {
  /**  */
  month?: number;

  /**  */
  value?: number;
}

export interface CompanyMonthlyTicketReportDetail {
  /**  */
  month?: number;

  /**  */
  cashierTicketAmount?: number;

  /**  */
  noOfCashierTickets?: number;

  /**  */
  onlineTicketAmount?: number;

  /**  */
  noOfOnlineTickets?: number;
}

export interface CompanyNotificationDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  applicationType?: MtopoApplication;

  /**  */
  notificationModule?: NotificationModuleType;

  /**  */
  notificationType?: NotificationCategoryType;

  /**  */
  englishContent?: string;

  /**  */
  frenchContent?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface CompanyNotificationDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyNotificationDto[];
}

export interface CompanyPaymentPartnersResponse {
  /**  */
  countryId?: string;

  /**  */
  partners?: PaymentPartnerAutocompletionModel[];
}

export interface CompanyRevenueReportModel {
  /**  */
  monthlyReports?: CompanyMonthlyRevenueReportDetail[];

  /**  */
  dailyReports?: CompanyDailyRevenueReportDetail[];
}

export interface CompanySaleModificationReportDto {
  /**  */
  modificationId?: string;

  /**  */
  createdOn?: Date;

  /**  */
  bookingRefNo?: string;

  /**  */
  oldTicketRefNo?: string;

  /**  */
  newTicketRefNo?: string;

  /**  */
  sellStationId?: string;

  /**  */
  sellStationName?: string;

  /**  */
  registerId?: string;

  /**  */
  registerName?: string;

  /**  */
  cashierId?: string;

  /**  */
  cashierName?: string;

  /**  */
  difference?: number;

  /**  */
  settlement?: TicketModificationSettlement;
}

export interface CompanySaleTicketReportDto {
  /**  */
  bookingRefNo?: string;

  /**  */
  createdOn?: Date;

  /**  */
  departureDate?: Date;

  /**  */
  sellStationId?: string;

  /**  */
  sellStationName?: string;

  /**  */
  registerId?: string;

  /**  */
  registerName?: string;

  /**  */
  cashierId?: string;

  /**  */
  cashierName?: string;

  /**  */
  destinationId?: string;

  /**  */
  destinationName?: string;

  /**  */
  journeyType?: JourneyType;

  /**  */
  ticketAmount?: number;

  /**  */
  discountAmount?: number;

  /**  */
  cancelledAmount?: number;

  /**  */
  outStandingAmount?: number;
}

export interface CompanySaleTicketReportResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanySaleTicketReportDto[];

  /**  */
  sellStations?: SellStationSummaryReport[];

  /**  */
  totalTicketAmount?: number;

  /**  */
  totalDiscountAmount?: number;

  /**  */
  totalCancelledAmount?: number;

  /**  */
  totalOutStandingAmount?: number;

  /**  */
  totalModificationAmount?: number;

  /**  */
  modifications?: CompanySaleModificationReportDto[];
}

export interface CompanySettingModel {
  /**  */
  id?: string;

  /**  */
  carrierCode?: string;

  /**  */
  dateFormat?: string;

  /**  */
  printLanguage?: string;

  /**  */
  timeFormat?: string;

  /**  */
  insuranceExpirationDays?: number;

  /**  */
  distanceUnit?: string;

  /**  */
  weightUnit?: string;

  /**  */
  intervalDays?: number;

  /**  */
  tripRangeValue?: number;

  /**  */
  orangeBfuSerId?: string;

  /**  */
  orangeBfPassword?: string;

  /**  */
  smsServiceUserName?: string;

  /**  */
  smsServicePassword?: string;

  /**  */
  actionCasse?: number;

  /**  */
  nbrVoyage?: number;

  /**  */
  tripSearchHoursGapSetup?: number;

  /**  */
  tripSalesLimitTime?: number;

  /**  */
  tripBoardingLimitTime?: number;

  /**  */
  ticketExpirationDays?: number;

  /**  */
  openTicketExpirationDays?: number;

  /**  */
  companyLogoImageFileName?: string;

  /**  */
  companyLogoImageUrl?: string;

  /**  */
  companyUrl?: string;

  /**  */
  shipmentInsuranceSettingType?: ShipmentInsuranceSettingType;

  /**  */
  shipmentInsuranceFlatAmount?: number;

  /**  */
  shipmentInsurancePercentage?: number;

  /**  */
  shipmentInsuranceRangeBaseSettings?: ShipmentInsuranceRangeBaseSetting[];

  /**  */
  defaultEmail?: string;

  /**  */
  bookingAllowedTime?: number;

  /**  */
  bookingConfirmationLimitTime?: number;

  /**  */
  bookingReminderLimitTime?: number;

  /**  */
  isSeatReleasedOnDepartureTime?: boolean;

  /**  */
  tripFillUpThresholdValue?: number;

  /**  */
  shipmentNotificationTariff?: number;

  /**  */
  isShipmentNotificationSenderEnabled?: boolean;

  /**  */
  isShipmentNotificationReceiverEnabled?: boolean;

  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  noOfStations?: string;

  /**  */
  companyImageUrl?: string;

  /**  */
  companySecretKey?: string;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  ownerId?: string;

  /**  */
  clientId?: string;

  /**  */
  qrAccountId?: string;

  /**  */
  planId?: string;

  /**  */
  noCc?: string;

  /**  */
  noIfu?: string;

  /**  */
  companyWebsiteUrl?: string;

  /**  */
  employerNo?: string;

  /**  */
  isEmailNotificationAllowed?: boolean;

  /**  */
  isSmsNotificationAllowed?: boolean;

  /**  */
  ticketModificationLimitTime?: number;

  /**  */
  isSellOnTheGoSegmentBaseTariff?: boolean;

  /**  */
  isOrangeBfPasswordSet?: boolean;

  /**  */
  isSmsServicePasswordSet?: boolean;

  /**  */
  isCompanySecretKeySet?: boolean;
}

export interface CompanySmsServiceUrlDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  countryId?: string;

  /**  */
  countryCode?: string;

  /**  */
  countryName?: string;

  /**  */
  smsServiceUrl?: string;
}

export interface CompanySmsServiceUrlDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanySmsServiceUrlDto[];
}

export interface CompanySmsServiceUrlModel {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  countryId?: string;

  /**  */
  smsServiceUrl?: string;
}

export interface CompanySmsSetting {
  /**  */
  smsServiceUserName?: string;

  /**  */
  smsServicePassword?: string;

  /**  */
  countryCode?: string;

  /**  */
  smsServiceUrl?: string;

  /**  */
  isSmsServicePasswordSet?: boolean;
}

export interface CompanyTicketClassDto {
  /**  */
  id?: string;

  /**  */
  baseTicketClassName?: string;

  /**  */
  ticketClassId?: string;

  /**  */
  name?: string;

  /**  */
  seatColor?: string;

  /**  */
  isStandard?: boolean;
}

export interface CompanyTicketClassDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyTicketClassDto[];
}

export interface CompanyTicketInfoModel {
  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  logo?: string;

  /**  */
  companyUrl?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface CompanyTripDetailReportDto {
  /**  */
  tripId?: string;

  /**  */
  tripName?: string;

  /**  */
  busName?: string;

  /**  */
  distance?: number;

  /**  */
  departureDate?: Date;

  /**  */
  noOfShipment?: number;

  /**  */
  noOfBaggage?: number;

  /**  */
  noOfBooking?: number;

  /**  */
  noOfPassenger?: number;
}

export interface CompanyTripDetailReportDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyTripDetailReportDto[];
}

export interface CompanyTripIncomeReportDto {
  /**  */
  tripId?: string;

  /**  */
  plannedDepartureDate?: Date;

  /**  */
  tripName?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  noOfPassenger?: number;

  /**  */
  occupancyRate?: number;

  /**  */
  totalSeats?: number;

  /**  */
  revenue?: number;

  /**  */
  noOfTicket?: number;

  /**  */
  cancelledAmount?: number;

  /**  */
  outStandingAmount?: number;
}

export interface CompanyTripIncomeReportResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyTripIncomeReportDto[];

  /**  */
  totalRevenueAmount?: number;

  /**  */
  totalCancelledAmount?: number;

  /**  */
  totalOutStandingAmount?: number;
}

export interface CompanyTripReportDto {
  /**  */
  date?: Date;

  /**  */
  noOfTrip?: number;

  /**  */
  noOfBus?: number;

  /**  */
  distance?: number;

  /**  */
  noOfPassenger?: number;

  /**  */
  noOfShipment?: number;

  /**  */
  noOfBooking?: number;
}

export interface CompanyTripReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;

  /**  */
  routeId?: string;
}

export interface CompanyUnEarnedRevenueReportDto {
  /**  */
  date?: Date;

  /**  */
  ticketAmount?: number;
}

export interface CompanyUnEarnedRevenueReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;
}

export interface CompanyUserDetailModel {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  email?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  roles?: string[];

  /**  */
  permissions?: string[];

  /**  */
  imgUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  userRemarks?: string;

  /**  */
  isBlackListed?: boolean;

  /**  */
  canLogin?: boolean;

  /**  */
  jobTitle?: string;

  /**  */
  employeeCategoryId?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  isCadre?: boolean;

  /**  */
  igrParts?: number;

  /**  */
  contractType?: string;

  /**  */
  seniority?: string;

  /**  */
  cnpsId?: string;

  /**  */
  employment?: string;

  /**  */
  salaryCategory?: string;

  /**  */
  qualification?: string;

  /**  */
  employeeType?: EmployeeType;

  /**  */
  employeeUniqueId?: string;

  /**  */
  employeeCode?: string;

  /**  */
  employeeStartDate?: Date;

  /**  */
  isMobilePaymentSelected?: boolean;

  /**  */
  isBankPaymentSelected?: boolean;

  /**  */
  isCashPaymentSelected?: boolean;

  /**  */
  mobileAccountNumber?: string;

  /**  */
  bankAccountNumber?: string;

  /**  */
  mobileAccountPortion?: number;

  /**  */
  bankAccountPortion?: number;

  /**  */
  cashPortion?: number;

  /**  */
  lastLogin?: Date;

  /**  */
  createdOn?: Date;

  /**  */
  updatedOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface CompanyUserDto {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  email?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  imgUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  userRemarks?: string;

  /**  */
  isBlackListed?: boolean;

  /**  */
  canLogin?: boolean;

  /**  */
  jobTitle?: string;

  /**  */
  employeeCategory?: string;

  /**  */
  isCadre?: boolean;

  /**  */
  igrParts?: number;

  /**  */
  contractType?: string;

  /**  */
  seniority?: string;

  /**  */
  cnpsId?: string;

  /**  */
  employment?: string;

  /**  */
  salaryCategory?: string;

  /**  */
  qualification?: string;

  /**  */
  employeeType?: EmployeeType;

  /**  */
  employeeUniqueId?: string;

  /**  */
  employeeCode?: string;

  /**  */
  lastLogin?: Date;

  /**  */
  createdOn?: Date;

  /**  */
  updatedOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface CompanyUserDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CompanyUserDto[];
}

export interface CompanyUserExportRequest {
  /**  */
  searchText?: string;

  /**  */
  employeeType?: EmployeeType;

  /**  */
  userName?: string;

  /**  */
  jobTitle?: string;

  /**  */
  columns: string[];
}

export interface ConektoUserAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  userName?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  emailAddress?: string;
}

export interface ConektoUserDetailModel {
  /**  */
  id?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  userName?: string;

  /**  */
  userSource?: UserSource;

  /**  */
  gender?: PassengerGender;

  /**  */
  dateOfBirth?: Date;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  phoneNumberConfirmed?: boolean;

  /**  */
  emailAddress?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  lastLogin?: Date;

  /**  */
  createdOn?: Date;

  /**  */
  imgUrl?: string;

  /**  */
  profileName?: string;

  /**  */
  bio?: string;

  /**  */
  userCode?: number;

  /**  */
  currentWalletBalance?: number;

  /**  */
  isUserWalletBlocked?: boolean;

  /**  */
  isActive?: boolean;
}

export interface ConektoUserPagingDto {
  /**  */
  id?: string;

  /**  */
  fullName?: string;

  /**  */
  userSource?: UserSource;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  phoneNumberConfirmed?: boolean;

  /**  */
  emailAddress?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  noOfBooking?: number;

  /**  */
  isUserWalletBlocked?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  createdOn?: Date;
}

export interface ConektoUserPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: ConektoUserPagingDto[];
}

export interface ConfirmEmailModel {
  /**  */
  userId?: string;

  /**  */
  code?: string;
}

export interface ConflictTripDetailModel {
  /**  */
  ticketId?: string;

  /**  */
  bookingTripId?: string;

  /**  */
  tripDetailId?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  ticketAmount?: number;

  /**  */
  ticketStatus?: TicketStatus;

  /**  */
  tariffParameterId?: string;

  /**  */
  passengerFirstName?: string;

  /**  */
  passengerLastName?: string;

  /**  */
  tripCode?: string;

  /**  */
  tripName?: string;

  /**  */
  tripRouteType?: TripRouteType;

  /**  */
  seatingModelName?: string;

  /**  */
  seatingModelType?: SeatingType;

  /**  */
  sourceId?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationId?: string;

  /**  */
  destinationName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  seatId?: string;

  /**  */
  seatKey?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassId?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  tripStatus?: TicketStatus;

  /**  */
  tripAmount?: number;
}

export interface CorrectPassengerPhoneRequest {
  /**  */
  passengerId?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;
}

export interface CountryModel {
  /**  */
  id?: string;

  /**  */
  countryName?: string;

  /**  */
  noOfGsmOperators?: number;

  /**  */
  nationalNumLength?: number;

  /**  */
  internationalCountryCode?: string;

  /**  */
  countryImageFlagUrl?: string;

  /**  */
  alphaCode?: string;

  /**  */
  timeZone?: number;

  /**  */
  isOperating?: boolean;
}

export interface CountryModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: CountryModel[];
}

export interface CreateCompanyRoleModel {
  /**  */
  name?: string;

  /**  */
  isTransportRole?: boolean;

  /**  */
  isPOSRole?: boolean;

  /**  */
  permissions?: string[];
}

export interface CreateCompanyUserModel {
  /**  */
  employeeUniqueId?: string;

  /**  */
  employeeCode?: string;

  /**  */
  isMobilePaymentSelected?: boolean;

  /**  */
  isBankPaymentSelected?: boolean;

  /**  */
  isCashPaymentSelected?: boolean;

  /**  */
  mobileAccountNumber?: string;

  /**  */
  bankAccountNumber?: string;

  /**  */
  mobileAccountPortion?: number;

  /**  */
  bankAccountPortion?: number;

  /**  */
  cashPortion?: number;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  email: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  canLogin?: boolean;

  /**  */
  imageUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  employeeType: EmployeeType;

  /**  */
  employeeStartDate?: Date;

  /**  */
  remarks?: string;

  /**  */
  roles: string[];

  /**  */
  jobTitle?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  employeeCategoryId?: string;

  /**  */
  isCadre?: boolean;

  /**  */
  igrParts?: number;

  /**  */
  contractType?: string;

  /**  */
  seniority?: string;

  /**  */
  cnpsId?: string;

  /**  */
  employment?: string;

  /**  */
  salaryCategory?: string;

  /**  */
  qualification?: string;
}

export interface CreateGlobalUserModel {
  /**  */
  id?: string;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  email: string;

  /**  */
  phoneCode: string;

  /**  */
  phoneNumber: string;

  /**  */
  imageUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  remarks?: string;

  /**  */
  roles: string[];

  /**  */
  reportingManagerId?: string;
}

export interface CreateRegisterModel {
  /**  */
  id?: string;

  /**  */
  registerName?: string;

  /**  */
  openingHoursFrom?: string;

  /**  */
  openingHoursTo?: string;

  /**  */
  stationId?: string;

  /**  */
  startingCash?: number;

  /**  */
  printDestination?: PrintDestination;

  /**  */
  loyaltyClient?: boolean;

  /**  */
  actionAnnulation?: boolean;

  /**  */
  receiptDefaultPrinter?: ReceiptPrinter;

  /**  */
  ticketDefaultPrinter?: TicketPrinter;

  /**  */
  shipmentLabelDefaultPrinter?: ShipmentLabelPrinter;

  /**  */
  registerCashiersUserIds?: string[];

  /**  */
  registerStatus?: RegisterStatus;
}

export interface CreateSegmentModel {
  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;

  /**  */
  routeId?: string;

  /**  */
  distance?: number;
}

export interface CreateTerminalRequest {
  /**  */
  name?: string;

  /**  */
  scopeType?: number;

  /**  */
  scopeId?: string;
}

export interface CreateTransportImportHistoryModel {
  /**  */
  importType?: ImportType;

  /**  */
  logFileUrl?: string;

  /**  */
  logFileName?: string;
}

export interface CreateUpdateAdvertisingDetailModel {
  /**  */
  order?: number;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  advertisingDetailType?: AdvertisingDetailType;

  /**  */
  videoThumbnailUrl?: string;

  /**  */
  contentUrl?: string;

  /**  */
  videoId?: string;

  /**  */
  videoPlayerType?: VideoPlayerType;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  clickAction?: AdvertisingClickAction;

  /**  */
  tripCompanyId?: string;

  /**  */
  baseTripId?: string;

  /**  */
  externalUrl?: string;
}

export interface CreateUpdateBaseTariffParameterModel {
  /**  */
  id?: string;

  /**  */
  code: string;

  /**  */
  name: string;

  /**  */
  isStandard?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  category?: TariffCategory;

  /**  */
  passengerType?: PassengerType;
}

export interface CreateUpdateBoxCategoryModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  boxTypeId?: string;
}

export interface CreateUpdateBoxTypeModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface CreateUpdateBoxVolumeModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  value?: number;
}

export interface CreateUpdateBoxWeightModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface CreateUpdateBusBrandModel {
  /**  */
  id?: string;

  /**  */
  brandName: string;

  /**  */
  brandSymbol: string;

  /**  */
  brandCountry?: string;
}

export interface CreateUpdateBusDocumentModel {
  /**  */
  id?: string;

  /**  */
  fileName: string;

  /**  */
  fileUrl: string;

  /**  */
  busId?: string;
}

export interface CreateUpdateBusInsuranceModel {
  /**  */
  id?: string;

  /**  */
  startDate?: Date;

  /**  */
  expiryDate?: Date;

  /**  */
  policyNumber?: string;

  /**  */
  busId?: string;

  /**  */
  busInsurerId?: string;
}

export interface CreateUpdateBusModel {
  /**  */
  id?: string;

  /**  */
  busName?: string;

  /**  */
  serialNo?: string;

  /**  */
  chassisNo?: string;

  /**  */
  motorPower?: string;

  /**  */
  plateNumber?: string;

  /**  */
  acquisitionDate?: Date;

  /**  */
  baggageCapacity?: string;

  /**  */
  transportVendorId?: string;

  /**  */
  purchaseOrderDetailId?: string;

  /**  */
  busModelId?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  busBrandId?: string;

  /**  */
  initialColor?: string;

  /**  */
  staffIds?: string[];
}

export interface CreateUpdateBusModelModel {
  /**  */
  id?: string;

  /**  */
  modelName: string;

  /**  */
  modelPower?: string;

  /**  */
  modelYear?: string;

  /**  */
  busBrandId: string;
}

export interface CreateUpdateBusStatusHistoryModel {
  /**  */
  id?: string;

  /**  */
  busId?: string;

  /**  */
  statusId?: string;

  /**  */
  statusDateTime?: Date;

  /**  */
  statusStation?: string;

  /**  */
  statusComment?: string;
}

export interface CreateUpdateBusStatusModel {
  /**  */
  id?: string;

  /**  */
  statusName: string;
}

export interface CreateUpdateCityModel {
  /**  */
  id?: string;

  /**  */
  cityName?: string;

  /**  */
  cityCode?: string;

  /**  */
  regionId?: string;
}

export interface CreateUpdateCompanyAccountModel {
  /**  */
  id?: string;

  /**  */
  paymentPartnerType?: PaymentPartnerType;

  /**  */
  paymentPartnerId?: string;

  /**  */
  accountOwner: string;

  /**  */
  accountNumber: string;

  /**  */
  accountType?: CompanyAccountType;

  /**  */
  countryId?: string;

  /**  */
  isActive?: boolean;
}

export interface CreateUpdateCompanyNotificationModel {
  /**  */
  id?: string;

  /**  */
  applicationType: MtopoApplication;

  /**  */
  notificationModule: NotificationModuleType;

  /**  */
  notificationType: NotificationCategoryType;

  /**  */
  englishContent?: string;

  /**  */
  frenchContent?: string;
}

export interface CreateUpdateCompanyTicketClassModel {
  /**  */
  id?: string;

  /**  */
  ticketClassId?: string;

  /**  */
  name?: string;

  /**  */
  seatColor?: string;

  /**  */
  isStandard?: boolean;
}

export interface CreateUpdateCountryModel {
  /**  */
  id?: string;

  /**  */
  countryName?: string;

  /**  */
  noOfGsmOperators?: number;

  /**  */
  nationalNumLength?: number;

  /**  */
  internationalCountryCode?: string;

  /**  */
  countryImageFlagUrl?: string;

  /**  */
  alphaCode?: string;

  /**  */
  timeZone?: number;

  /**  */
  isOperating?: boolean;
}

export interface CreateUpdateGlobalDiscountModel {
  /**  */
  id?: string;

  /**  */
  promoCode?: string;

  /**  */
  autoApply?: boolean;

  /**  */
  promoPhotoUrl?: string;

  /**  */
  refNo?: string;

  /**  */
  applicationTarget?: DiscountApplicationTarget[];

  /**  */
  discountCompany?: DiscountCompany;

  /**  */
  discountCompanyIds?: string[];

  /**  */
  shortDescription?: string;

  /**  */
  description?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;

  /**  */
  discountUsage?: DiscountUsage;

  /**  */
  noOfApplyTimes?: number;

  /**  */
  discountUser?: DiscountUser;

  /**  */
  discountNewUserAfterDate?: Date;

  /**  */
  discountOldUserBeforeDate?: Date;

  /**  */
  discountCustomUserIds?: string[];

  /**  */
  discountType?: GlobalDiscountType;

  /**  */
  discountValue?: number;

  /**  */
  maxDiscountAmount?: number;

  /**  */
  isActive?: boolean;
}

export interface CreateUpdateInsurerModel {
  /**  */
  id?: string;

  /**  */
  name: string;

  /**  */
  phone: string;

  /**  */
  address?: string;
}

export interface CreateUpdateLianeAdvertisingModel {
  /**  */
  id?: string;

  /**  */
  title?: string;

  /**  */
  order?: number;

  /**  */
  advertisingScreen?: AdvertisingScreen;

  /**  */
  advertisingType?: AdvertisingType;

  /**  */
  advertisingDetails?: CreateUpdateAdvertisingDetailModel[];

  /**  */
  isActive?: boolean;
}

export interface CreateUpdateLianeCommonSettingModel {
  /**  */
  id?: string;

  /**  */
  confirmationBookingNotification?: ConfirmationBookingNotification;
}

export interface CreateUpdatePartnerAccountModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  id?: string;

  /**  */
  utilityPartnerId?: string;

  /**  */
  partnerAccountType?: PartnerAccountType;

  /**  */
  name?: string;

  /**  */
  accountOwner?: string;

  /**  */
  accountNumber?: string;
}

export interface CreateUpdatePartnerConnectivityModel {
  /**  */
  id?: string;

  /**  */
  partnerId?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  encryptionType?: EncryptionType;

  /**  */
  decryptionKey?: string;

  /**  */
  encryptionKey?: string;

  /**  */
  provider?: number;

  /**  */
  provider2?: number;

  /**  */
  payId?: number;

  /**  */
  payId2?: number;

  /**  */
  controller?: string;

  /**  */
  dataType?: string;

  /**  */
  ownPrivateKey?: string;

  /**  */
  orangePublicKey?: string;

  /**  */
  operatorId?: string;

  /**  */
  appId?: string;
}

export interface CreateUpdatePaymentPartnerModel {
  /**  */
  id?: string;

  /**  */
  partnerName?: string;

  /**  */
  partnerType?: PaymentPartnerType;

  /**  */
  address?: string;

  /**  */
  providerInterface?: number;

  /**  */
  cityId?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  monetaryZone?: string;

  /**  */
  logoImageUrl?: string;
}

export interface CreateUpdatePdfTemplateModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  cultureCode?: string;

  /**  */
  content?: string;
}

export interface CreateUpdatePlanModel {
  /**  */
  id?: string;

  /**  */
  planName?: string;

  /**  */
  noOfRegister?: number;

  /**  */
  transactionLimit?: number;

  /**  */
  turnover?: number;

  /**  */
  transactionFee?: number;

  /**  */
  monthlyFee?: number;

  /**  */
  paymentTermType?: PaymentTerms;

  /**  */
  paymentMethodType?: PaymentMode;

  /**  */
  planType?: PlanType;

  /**  */
  isPopular?: boolean;

  /**  */
  description?: string;

  /**  */
  availableApps?: SystemApp[];

  /**  */
  componentIds?: string[];

  /**  */
  serviceIds?: string[];
}

export interface CreateUpdateRegionModel {
  /**  */
  id?: string;

  /**  */
  regionName?: string;

  /**  */
  countryId?: string;
}

export interface CreateUpdateRouteLocationModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  placeId?: string;

  /**  */
  stationId?: string;
}

export interface CreateUpdateSeatingModelDetailModel {
  /**  */
  id?: string;

  /**  */
  entityName?: string;

  /**  */
  row?: number;

  /**  */
  column?: number;

  /**  */
  busEntityType?: BusEntityType;

  /**  */
  baseTicketClassId?: string;

  /**  */
  seatColor?: string;
}

export interface CreateUpdateSeatingModelModel {
  /**  */
  id?: string;

  /**  */
  seatingModelRef?: string;

  /**  */
  seatingModelName: string;

  /**  */
  noOfRows: number;

  /**  */
  seatingType: SeatingType;

  /**  */
  seatingModelDetails?: CreateUpdateSeatingModelDetailModel[];
}

export interface CreateUpdateServiceModel {
  /**  */
  id?: string;

  /**  */
  serviceName: string;

  /**  */
  countryId: string;

  /**  */
  activationDate?: Date;

  /**  */
  isEnabled?: boolean;

  /**  */
  description?: string;

  /**  */
  masterServiceType?: MasterService;

  /**  */
  availableApps?: SystemApp[];

  /**  */
  feePayingEntities?: FeePayingEntityModel[];

  /**  */
  feeSharingEntities?: FeeSharingEntityModel[];
}

export interface CreateUpdateShipmentTariffModel {
  /**  */
  id?: string;

  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;

  /**  */
  boxCategoryId?: string;

  /**  */
  boxWeightId?: string;

  /**  */
  boxVolumeId?: string;

  /**  */
  tariffAmount?: number;
}

export interface CreateUpdateStationModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  stationCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  displayPhoneNumber?: string;

  /**  */
  email?: string;

  /**  */
  address?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  stationImageUrl?: string;

  /**  */
  quartierName?: string;

  /**  */
  expenseApproverId?: string;

  /**  */
  isConnectionStation?: boolean;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  startingBalance?: number;

  /**  */
  stationAdministratorUserIds?: string[];

  /**  */
  stationSupervisorUserIds?: string[];
}

export interface CreateUpdateTicketCancellationPolicySettingModel {
  /**  */
  id?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  isPercentageBase?: boolean;

  /**  */
  plans?: CancellationPolicyPlan[];
}

export interface CreateUpdateTicketClassModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  seatColor?: string;

  /**  */
  isStandard?: boolean;
}

export interface CreateUpdateTicketModificationSettingModel {
  /**  */
  id?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  allowToModifyTicket?: boolean;

  /**  */
  isPercentageBase?: boolean;

  /**  */
  amount?: number;
}

export interface CreateUpdateTripDirectionModel {
  /**  */
  fromStationId?: string;

  /**  */
  toStationId?: string;

  /**  */
  directionPreview?: string;
}

export interface CreateUpdateTripLocationDetailsModel {
  /**  */
  routeLocationId?: string;

  /**  */
  stationId?: string;
}

export interface CreateUpdateTripLocationModel {
  /**  */
  baseTripId?: string;

  /**  */
  tripLocations?: CreateUpdateTripLocationDetailsModel[];

  /**  */
  tripDirections?: CreateUpdateTripDirectionModel[];
}

export interface CreateUpdateUserFollowUpDetailModel {
  /**  */
  id?: string;

  /**  */
  lianeUserId?: string;

  /**  */
  followUpDateTime?: Date;

  /**  */
  nextFollowUpDateTime?: Date;

  /**  */
  followUpType?: UserFollowUpType;

  /**  */
  comment?: string;
}

export interface CreateUpdateUtilityPartnerConnectivityModel {
  /**  */
  id?: string;

  /**  */
  partnerId?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  encryptionType?: EncryptionType;

  /**  */
  decryptionKey?: string;

  /**  */
  encryptionKey?: string;
}

export interface CreateUpdateUtilityPartnerModel {
  /**  */
  id?: string;

  /**  */
  providerInterface?: number;

  /**  */
  partnerName?: string;

  /**  */
  address?: string;

  /**  */
  cityId?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  monetaryZone?: string;
}

export interface CreditNoteDetailModel {
  /**  */
  creditNote?: CreditNoteListItemModel;

  /**  */
  issuedFor?: string;

  /**  */
  sourceNumber?: string;

  /**  */
  movements?: CreditNoteMovementModel[];
}

export interface CreditNoteListItemModel {
  /**  */
  id?: string;

  /**  */
  number?: string;

  /**  */
  holderName?: string;

  /**  */
  holderPhone?: string;

  /**  */
  amount?: number;

  /**  */
  balance?: number;

  /**  */
  issuedOn?: Date;

  /**  */
  issuedByName?: string;

  /**  */
  expiresOn?: Date;

  /**  */
  status?: string;

  /**  */
  useCount?: number;
}

export interface CreditNoteListResponse {
  /**  */
  items?: CreditNoteListItemModel[];

  /**  */
  total?: number;

  /**  */
  totalAmount?: number;

  /**  */
  totalBalance?: number;
}

export interface CreditNoteMovementModel {
  /**  */
  kind?: string;

  /**  */
  on?: Date;

  /**  */
  amount?: number;

  /**  */
  balanceAfter?: number;

  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  byName?: string;
}

export interface CurrentTripStationModel {
  /**  */
  id?: string;

  /**  */
  currentStation?: string;

  /**  */
  nextStation?: string;
}

export interface CurrentUserCompanyModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  logoUrl?: string;

  /**  */
  printLanguage?: string;

  /**  */
  dateFormat?: string;
}

export interface CurrentUserModel {
  /**  */
  id?: string;

  /**  */
  userType?: UserType;

  /**  */
  username?: string;

  /**  */
  email?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  imgUrl?: string;

  /**  */
  roles?: string[];

  /**  */
  permissions?: string[];

  /**  */
  company?: CurrentUserCompanyModel;

  /**  */
  language?: string;
}

export interface DiscountDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  value?: number;

  /**  */
  valueType?: DiscountValueType;

  /**  */
  beneficiaryType?: DiscountBeneficiaryType;

  /**  */
  targetType?: DiscountTargetType;
}

export interface DiscountDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: DiscountDto[];
}

export interface DiscountModel {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  name?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  value?: number;

  /**  */
  valueType?: DiscountValueType;

  /**  */
  beneficiaryType?: DiscountBeneficiaryType;

  /**  */
  beneficiaryEntityId?: string;

  /**  */
  passengerIds?: string[];

  /**  */
  targetType?: DiscountTargetType;

  /**  */
  routeId?: string;

  /**  */
  tripId?: string;

  /**  */
  segmentId?: string;
}

export interface DuplicateTripModel {
  /**  */
  tripId?: string;

  /**  */
  tripName?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  isRecurred?: boolean;

  /**  */
  recurrenceNumDays?: number[];
}

export interface EmailMessage {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  fromAddress?: string;

  /**  */
  fromName?: string;

  /**  */
  toEmails?: string;

  /**  */
  ccEmails?: string;

  /**  */
  bccEmails?: string;

  /**  */
  subject?: string;

  /**  */
  bodyContent?: string;

  /**  */
  createdOn?: Date;

  /**  */
  sentOn?: Date;

  /**  */
  error?: string;

  /**  */
  isSent?: boolean;
}

export interface EmailMessagePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: EmailMessage[];
}

export interface EmailTemplateModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  cultureCode?: string;

  /**  */
  subject?: string;

  /**  */
  body?: string;

  /**  */
  enabled?: boolean;

  /**  */
  toEmails?: string;

  /**  */
  ccEmails?: string;

  /**  */
  bccEmails?: string;

  /**  */
  includeAttachment?: boolean;
}

export interface EmailTemplateModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: EmailTemplateModel[];
}

export interface EmployeeCategoryAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface ExportBoxCategoryRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface ExportBoxTypeRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface ExportBoxVolumeRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface ExportBoxWeightRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface ExportConektoUserRequest {
  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  fullName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  emailAddress?: string;

  /**  */
  registrationFromDate?: Date;

  /**  */
  registrationToDate?: Date;

  /**  */
  phoneNumberConfirmed?: boolean;

  /**  */
  emailConfirmed?: boolean;
}

export interface ExportPassengerRequest {
  /**  */
  searchText?: string;

  /**  */
  companyId?: string;

  /**  */
  columns: string[];
}

export interface ExportSaleReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;

  /**  */
  countryId?: string;

  /**  */
  registerId?: string;

  /**  */
  cashierId?: string;
}

export interface ExportTripDetailReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;

  /**  */
  tripName?: string;
}

export interface ExportTripIncomeReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;
}

export interface FeePayingEntityModel {
  /**  */
  serviceFeePayingEntityType?: ServiceFeePayingEntityType;

  /**  */
  entityId?: string;

  /**  */
  rate?: number;

  /**  */
  isPercentageBase?: boolean;
}

export interface FeeSharingEntityModel {
  /**  */
  serviceFeeSharingEntityType?: ServiceFeeSharingEntityType;

  /**  */
  entityId?: string;

  /**  */
  rate?: number;

  /**  */
  isPercentageBase?: boolean;
}

export interface FileUploadResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  url?: string;

  /**  */
  fileName?: string;
}

export interface ForgotPasswordModel {
  /**  */
  token?: string;

  /**  */
  newPassword?: string;
}

export interface GetReconciliationPaymentAmountRequest {
  /**  */
  registerId?: string;

  /**  */
  cashierUserId?: string;

  /**  */
  startDateTime?: Date;

  /**  */
  endDateTime?: Date;
}

export interface GetReconciliationPaymentPagingRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  registerId?: string;

  /**  */
  cashierUserId?: string;

  /**  */
  startDateTime?: Date;

  /**  */
  endDateTime?: Date;
}

export interface GetTripDirectionResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  tripDirections?: TripDirectionDto[];
}

export interface GetTripLocationsResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  locations?: TripLocationDto[];
}

export interface GetTripPassengerResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  schedulePassengers?: TripPassengerModel[];

  /**  */
  sellOnTheGoPassengers?: TripPassengerModel[];
}

export interface GetTripSeatingModelRequest {
  /**  */
  tripId?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationStationId?: string;
}

export interface GlobalAvailableTripTariffRequest {
  /**  */
  journeyType?: JourneyType;

  /**  */
  departureSourceStationId?: string;

  /**  */
  departureDestinationStationId?: string;

  /**  */
  departureCompanyId?: string;

  /**  */
  returnCompanyId?: string;

  /**  */
  returnSourceStationId?: string;

  /**  */
  returnDestinationStationId?: string;
}

export interface GlobalCashierSellingAssignmentDto {
  /**  */
  cashierId?: string;

  /**  */
  cashierFirstName?: string;

  /**  */
  cashierLastName?: string;

  /**  */
  cashierUserName?: string;

  /**  */
  companyIds?: string[];
}

export interface GlobalCashierSellingAssignmentDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: GlobalCashierSellingAssignmentDto[];
}

export interface GlobalDiscountDto {
  /**  */
  id?: string;

  /**  */
  promoCode?: string;

  /**  */
  autoApply?: boolean;

  /**  */
  refNo?: string;

  /**  */
  promoPhotoUrl?: string;

  /**  */
  applicationTarget?: DiscountApplicationTarget[];

  /**  */
  discountCompany?: DiscountCompany;

  /**  */
  shortDescription?: string;

  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;

  /**  */
  discountUsage?: DiscountUsage;

  /**  */
  disCountType?: GlobalDiscountType;

  /**  */
  discountValue?: number;

  /**  */
  maxDiscountAmount?: number;

  /**  */
  isActive?: boolean;
}

export interface GlobalDiscountDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: GlobalDiscountDto[];
}

export interface GlobalUserDetailDto {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  userName?: string;

  /**  */
  employeeCode?: string;

  /**  */
  email?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  lastLogin?: Date;

  /**  */
  createdOn?: Date;

  /**  */
  updatedOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;

  /**  */
  imgUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  userRemarks?: string;

  /**  */
  isBlackListed?: boolean;

  /**  */
  reportingManagerId?: string;

  /**  */
  roleIds?: string[];
}

export interface GlobalUserDto {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  userName?: string;

  /**  */
  employeeCode?: string;

  /**  */
  email?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  lastLogin?: Date;

  /**  */
  createdOn?: Date;

  /**  */
  updatedOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;

  /**  */
  imgUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  userRemarks?: string;

  /**  */
  isBlackListed?: boolean;
}

export interface GlobalUserDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: GlobalUserDto[];
}

export interface GlobalUserExportRequest {
  /**  */
  searchText?: string;

  /**  */
  columns?: string[];
}

export interface GuidBaseAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface GuidBaseUpdateModel {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  id?: string;
}

export interface LianeAdvertisingDto {
  /**  */
  id?: string;

  /**  */
  title?: string;

  /**  */
  order?: number;

  /**  */
  advertisingScreen?: AdvertisingScreen;

  /**  */
  advertisingType?: AdvertisingType;

  /**  */
  isActive?: boolean;

  /**  */
  createdOn?: Date;
}

export interface LianeAdvertisingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: LianeAdvertisingDto[];
}

export interface LianeBookingPagingDto {
  /**  */
  bookingId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  sourceCityName?: string;

  /**  */
  destinationCityName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  journeyType?: JourneyType;

  /**  */
  status?: BookingStatus;

  /**  */
  payMode?: BookingPayMode;

  /**  */
  ticketAmount?: number;

  /**  */
  bookingDate?: Date;
}

export interface LianeBookingPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: LianeBookingPagingDto[];
}

export interface LianeTicketPagingDto {
  /**  */
  ticketId?: string;

  /**  */
  companyId?: string;

  /**  */
  companyName?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  passengerFirstName?: string;

  /**  */
  passengerLastName?: string;

  /**  */
  passengerType?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  createdOn?: Date;

  /**  */
  ticketStatus?: TicketStatus;
}

export interface LianeTicketPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: LianeTicketPagingDto[];
}

export interface LianeUserFollowUpDetailDto {
  /**  */
  id?: string;

  /**  */
  followUpDateTime?: Date;

  /**  */
  nextFollowUpDateTime?: Date;

  /**  */
  followUpType?: UserFollowUpType;

  /**  */
  comment?: string;
}

export interface LianeUserFollowUpDetailDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: LianeUserFollowUpDetailDto[];
}

export interface LogBaggageReconciliationRequest {
  /**  */
  employeeId?: string;

  /**  */
  totalReconciliationAmount?: number;

  /**  */
  amountDifference?: number;

  /**  */
  isCrossVerified?: boolean;

  /**  */
  comments?: string;
}

export interface LogReconciliationRequest {
  /**  */
  registerId?: string;

  /**  */
  cashierId?: string;

  /**  */
  totalReconciliationAmount?: number;

  /**  */
  amountDifference?: number;

  /**  */
  isCrossVerified?: boolean;

  /**  */
  comments?: string;
}

export interface LogSellOnTheGoReconciliationRequest {
  /**  */
  employeeId?: string;

  /**  */
  totalReconciliationAmount?: number;

  /**  */
  amountDifference?: number;

  /**  */
  isCrossVerified?: boolean;

  /**  */
  comments?: string;
}

export interface LoginModel {
  /**  */
  email: string;

  /**  */
  password: string;
}

export interface LoginResponseModel {
  /**  */
  success?: boolean;

  /**  */
  twoFactorRequired?: boolean;

  /**  */
  twoFactorToken?: string;

  /**  */
  twoFactorProviders?: string[];

  /**  */
  authenticatorEnrolled?: boolean;

  /**  */
  authenticatorEnrollmentRequired?: boolean;

  /**  */
  error?: string;

  /**  */
  accessToken?: string;

  /**  */
  refreshToken?: string;

  /**  */
  isPasswordExpired?: boolean;

  /**  */
  expiryDuration?: number;

  /**  */
  currentUser?: CurrentUserModel;
}

export interface Notification {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  message?: string;

  /**  */
  extraData?: string;

  /**  */
  senderId?: string;

  /**  */
  toUserId?: string;

  /**  */
  senderName?: string;

  /**  */
  isEnable?: boolean;

  /**  */
  createdOn?: Date;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedBy?: string;

  /**  */
  sentOn?: Date;
}

export interface NotificationPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: Notification[];
}

export interface PartnerAccountDto {
  /**  */
  id?: string;

  /**  */
  utilityPartnerId?: string;

  /**  */
  partnerAccountType?: PartnerAccountType;

  /**  */
  name?: string;

  /**  */
  accountOwner?: string;

  /**  */
  accountNumber?: string;

  /**  */
  isActive?: boolean;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface PartnerAccountDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PartnerAccountDto[];
}

export interface PartnerConnectivityDetailModel {
  /**  */
  id?: string;

  /**  */
  partnerId?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  isPasswordSet?: boolean;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  encryptionType?: EncryptionType;

  /**  */
  decryptionKey?: string;

  /**  */
  encryptionKey?: string;

  /**  */
  provider?: number;

  /**  */
  provider2?: number;

  /**  */
  payId?: number;

  /**  */
  payId2?: number;

  /**  */
  controller?: string;

  /**  */
  dataType?: string;

  /**  */
  isOwnPrivateKeySet?: boolean;

  /**  */
  orangePublicKey?: string;

  /**  */
  operatorId?: string;

  /**  */
  appId?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface PartnerConnectivityDto {
  /**  */
  id?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface PartnerConnectivityDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PartnerConnectivityDto[];
}

export interface PassengerAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  address?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  postalCode?: string;
}

export interface PassengerDetailModel {
  /**  */
  id?: string;

  /**  */
  isMainPassenger?: boolean;

  /**  */
  holderFirstName?: string;

  /**  */
  holderLastName?: string;

  /**  */
  holderDateOfBirth?: Date;

  /**  */
  holderGender?: PassengerGender;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  address?: string;

  /**  */
  profession?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  postalCode?: string;

  /**  */
  isTicketBookingAllowed?: boolean;
}

export interface PassengerIdentityDetailModel {
  /**  */
  passengerId?: string;

  /**  */
  identityType?: IdentityDocumentType;

  /**  */
  uploadDocuments?: string[];

  /**  */
  documentNumber?: string;

  /**  */
  countryCode?: string;
}

export interface PassengerInvalidPhoneModel {
  /**  */
  id?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  lastTravelDate?: Date;
}

export interface PassengerPagingDto {
  /**  */
  id?: string;

  /**  */
  tariffParameterId?: string;

  /**  */
  passengerType?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  address?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  countryName?: string;

  /**  */
  isTicketBookingAllowed?: boolean;
}

export interface PassengerPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PassengerPagingDto[];
}

export interface PassengerProfileHistoryModel {
  /**  */
  passengerId?: string;

  /**  */
  operationId?: string;

  /**  */
  source?: string;

  /**  */
  field?: string;

  /**  */
  oldValue?: string;

  /**  */
  newValue?: string;

  /**  */
  changedByName?: string;

  /**  */
  changedOn?: Date;
}

export interface PassengerReportModel {
  /**  */
  monthlyReports?: CompanyMonthlyPassengerReportDetail[];

  /**  */
  dailyReports?: CompanyDailyPassengerReportDetail[];
}

export interface PasswordPolicyDto {
  /**  */
  id?: string;

  /**  */
  passwordLength?: number;

  /**  */
  noOfUpperCase?: number;

  /**  */
  noOfLowerCase?: number;

  /**  */
  noOfSpecialCharacters?: number;

  /**  */
  noOfNumericCharacters?: number;

  /**  */
  allowNameCharacters?: boolean;

  /**  */
  preventPasswordReuse?: boolean;

  /**  */
  passwordExpirationDays?: number;
}

export interface PaymentPartnerAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface PaymentPartnerDetail {
  /**  */
  id?: string;

  /**  */
  partnerName?: string;

  /**  */
  partnerType?: PaymentPartnerType;

  /**  */
  address?: string;

  /**  */
  providerInterface?: number;

  /**  */
  cityId?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  monetaryZone?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface PaymentPartnerDto {
  /**  */
  id?: string;

  /**  */
  partnerName?: string;

  /**  */
  partnerType?: PaymentPartnerType;

  /**  */
  address?: string;

  /**  */
  providerInterface?: number;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  monetaryZone?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface PaymentPartnerDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PaymentPartnerDto[];
}

export interface PaymentPartnerExportRequest {
  /**  */
  searchText?: string;

  /**  */
  partnerType: PaymentPartnerType;

  /**  */
  columns: string[];
}

export interface PdfPagingResponse {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  cultureCode?: string;

  /**  */
  content?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedAt?: Date;

  /**  */
  updatedOn?: string;

  /**  */
  updatedById?: string;
}

export interface PdfPagingResponsePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PdfPagingResponse[];
}

export interface PdfTemplateNameModel {
  /**  */
  key?: string;

  /**  */
  name?: string;
}

export interface PlanModel {
  /**  */
  id?: string;

  /**  */
  planName?: string;

  /**  */
  noOfRegister?: number;

  /**  */
  transactionLimit?: number;

  /**  */
  turnover?: number;

  /**  */
  transactionFee?: number;

  /**  */
  monthlyFee?: number;

  /**  */
  paymentTermType?: PaymentTerms;

  /**  */
  paymentMethodType?: PaymentMode;

  /**  */
  planType?: PlanType;

  /**  */
  isPopular?: boolean;

  /**  */
  description?: string;
}

export interface PlanModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: PlanModel[];
}

export interface PlanServiceModel {
  /**  */
  id?: string;

  /**  */
  serviceName?: string;

  /**  */
  description?: string;
}

export interface PlanSubscribeViewModel {
  /**  */
  planId?: string;

  /**  */
  services?: PlanServiceModel[];

  /**  */
  planName?: string;

  /**  */
  description?: string;

  /**  */
  price?: number;

  /**  */
  existingComponentsFees?: number;

  /**  */
  hidePaySection?: boolean;
}

export interface PlanSubscriptionModel {
  /**  */
  id?: string;

  /**  */
  planName?: string;

  /**  */
  noOfRegister?: number;

  /**  */
  transactionLimit?: number;

  /**  */
  turnover?: number;

  /**  */
  transactionFee?: number;

  /**  */
  monthlyFee?: number;

  /**  */
  paymentTermType?: PaymentTerms;

  /**  */
  paymentMethodType?: PaymentMode;

  /**  */
  description?: string;

  /**  */
  components?: string[];

  /**  */
  isActive?: boolean;

  /**  */
  isPopular?: boolean;

  /**  */
  isFreeForever?: boolean;

  /**  */
  trial?: boolean;

  /**  */
  sequenceNumber?: number;
}

export interface ReconciliationBookingPaymentDto {
  /**  */
  paymentDate?: Date;

  /**  */
  amount?: number;

  /**  */
  bookingId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  bookingDate?: Date;

  /**  */
  cancelledAmount?: number;

  /**  */
  outStandingAmount?: number;
}

export interface ReconciliationBookingPaymentDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: ReconciliationBookingPaymentDto[];
}

export interface RefreshTokenRequest {
  /**  */
  userId?: string;

  /**  */
  refreshToken?: string;
}

export interface RefreshTokenResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  userId?: string;

  /**  */
  accessToken?: string;

  /**  */
  refreshToken?: string;

  /**  */
  expiryDuration?: number;
}

export interface RegionModel {
  /**  */
  id?: string;

  /**  */
  regionName?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;
}

export interface RegionModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RegionModel[];
}

export interface RegisterBookingPaymentModel {
  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  payMode?: BookingPayMode;

  /**  */
  totalAmount?: number;

  /**  */
  cashChange?: number;

  /**  */
  cashTendered?: number;

  /**  */
  transactionId?: string;

  /**  */
  approvalCode?: string;

  /**  */
  transactionMessage?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;
}

export interface RegisterBookingPaymentModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RegisterBookingPaymentModel[];
}

export interface RegisterCashierInfo {
  /**  */
  id?: string;

  /**  */
  fistName?: string;

  /**  */
  lastName?: string;
}

export interface RegisterCompanyModel {
  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  email: string;

  /**  */
  password: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  carrierCode: string;

  /**  */
  storeName: string;

  /**  */
  noOfStores?: string;

  /**  */
  address: string;

  /**  */
  countryId: string;

  /**  */
  cityId: string;

  /**  */
  regionId: string;
}

export interface RegisterDetailModel {
  /**  */
  id?: string;

  /**  */
  registerName?: string;

  /**  */
  openingHoursFrom?: string;

  /**  */
  openingHoursTo?: string;

  /**  */
  stationId?: string;

  /**  */
  companyId?: string;

  /**  */
  startingCash?: number;

  /**  */
  currentBalance?: number;

  /**  */
  receiptDefaultPrinter?: ReceiptPrinter;

  /**  */
  ticketDefaultPrinter?: TicketPrinter;

  /**  */
  shipmentLabelDefaultPrinter?: ShipmentLabelPrinter;

  /**  */
  registerStatus?: RegisterStatus;

  /**  */
  printDestination?: PrintDestination;

  /**  */
  loyaltyClient?: boolean;

  /**  */
  actionAnnulation?: boolean;

  /**  */
  cashierIds?: string[];

  /**  */
  cashiers?: RegisterCashierInfo[];
}

export interface RegisterPagingResponseModel {
  /**  */
  id?: string;

  /**  */
  registerName?: string;

  /**  */
  openingHoursFrom?: string;

  /**  */
  openingHoursTo?: string;

  /**  */
  stationId?: string;

  /**  */
  stationName?: string;

  /**  */
  companyId?: string;

  /**  */
  startingCash?: number;

  /**  */
  currentBalance?: number;

  /**  */
  registerStatus?: RegisterStatus;

  /**  */
  cashierIds?: string[];

  /**  */
  cashiers?: RegisterCashierInfo[];
}

export interface RegisterPagingResponseModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RegisterPagingResponseModel[];
}

export interface RegisterReconciliationModel {
  /**  */
  registerId?: string;

  /**  */
  registerName?: string;

  /**  */
  cashierUserName?: string;

  /**  */
  cashierUserId?: string;

  /**  */
  cashierName?: string;

  /**  */
  cashierId?: string;

  /**  */
  lastReconciliationDate?: Date;

  /**  */
  bookingTotalAmount?: number;

  /**  */
  shipmentTotalAmount?: number;

  /**  */
  parkingTotalAmount?: number;

  /**  */
  expenseTotalAmount?: number;

  /**  */
  creditNotesIssuedCount?: number;

  /**  */
  creditNotesIssuedAmount?: number;

  /**  */
  creditNotesUsedCount?: number;

  /**  */
  creditNotesUsedAmount?: number;

  /**  */
  creditNotesReturnedAmount?: number;

  /**  */
  allowReconciliation?: boolean;
}

export interface RegisterShipmentPaymentModel {
  /**  */
  shipmentId?: string;

  /**  */
  shipmentRefNo?: string;

  /**  */
  shipmentRefNoOffline?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  receiptRefNoOffline?: string;

  /**  */
  payMode?: BookingPayMode;

  /**  */
  totalAmount?: number;

  /**  */
  transactionId?: string;

  /**  */
  approvalCode?: string;

  /**  */
  shipmentStatus?: ShipmentStatus;

  /**  */
  customerName?: string;

  /**  */
  reachedDate?: Date;

  /**  */
  createdOn?: Date;
}

export interface RegisterShipmentPaymentModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RegisterShipmentPaymentModel[];
}

export interface ReportingManagerModel {
  /**  */
  id?: string;

  /**  */
  userName?: string;

  /**  */
  email?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;
}

export interface ReportingManagerModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: ReportingManagerModel[];
}

export interface ReviewTicketCancellationRequestModel {
  /**  */
  comment?: string;
}

export interface RevokeTerminalRequest {
  /**  */
  reason?: string;
}

export interface RoleDetailModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  normalizedName?: string;

  /**  */
  permissions?: string[];

  /**  */
  isSystem?: boolean;

  /**  */
  isCustomized?: boolean;

  /**  */
  requiresTwoFactor?: boolean;
}

export interface RoleDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  normalizedName?: string;

  /**  */
  isAdminRole?: boolean;

  /**  */
  isTransportRole?: boolean;

  /**  */
  isPOSRole?: boolean;

  /**  */
  isSystem?: boolean;

  /**  */
  isCustomized?: boolean;

  /**  */
  requiresTwoFactor?: boolean;
}

export interface RoleDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RoleDto[];
}

export interface RouteAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  routeRefNumber?: string;
}

export interface RouteBasicInfoModel {
  /**  */
  id?: string;

  /**  */
  routeName?: string;

  /**  */
  routeInternalCode?: string;

  /**  */
  routeCode?: string;

  /**  */
  distance?: number;

  /**  */
  sourceStationId?: string;

  /**  */
  sourceStationName?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  destinationStationName?: string;
}

export interface RouteDto {
  /**  */
  id?: string;

  /**  */
  routeName?: string;

  /**  */
  routeInternalCode?: string;

  /**  */
  routeType?: RouteType;

  /**  */
  originStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  distance?: number;

  /**  */
  noOfStops?: number;
}

export interface RouteDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RouteDto[];
}

export interface RouteExportRequest {
  /**  */
  searchText?: string;

  /**  */
  routeType?: RouteType;

  /**  */
  stationId?: string;

  /**  */
  columns?: string[];
}

export interface RouteLocationDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  placeId?: string;

  /**  */
  stationId?: string;
}

export interface RouteLocationDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: RouteLocationDto[];
}

export interface RouteModel {
  /**  */
  id?: string;

  /**  */
  routeName?: string;

  /**  */
  routeInternalCode?: string;

  /**  */
  routeCode?: string;

  /**  */
  routeType?: RouteType;

  /**  */
  distance?: number;

  /**  */
  isRoundTrip?: boolean;

  /**  */
  sourceCountryId?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationCountryId?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  routeStops?: RouteStopModel[];
}

export interface RouteStopDto {
  /**  */
  id?: string;

  /**  */
  stationId?: string;

  /**  */
  stationName?: string;

  /**  */
  distanceFromSource?: number;

  /**  */
  order?: number;
}

export interface RouteStopModel {
  /**  */
  stationId?: string;

  /**  */
  distanceFromSource?: number;
}

export interface SaleWithGroupReportDto {
  /**  */
  stationId?: string;

  /**  */
  station?: string;

  /**  */
  date?: Date;

  /**  */
  amount?: number;
}

export interface SaleWithGroupReportRequest {
  /**  */
  fromDate?: Date;

  /**  */
  toDate?: Date;
}

export interface SaveBaggageTariffModel {
  /**  */
  id?: string;

  /**  */
  freeBags?: number;

  /**  */
  maxBagsAllowed?: number;

  /**  */
  standardTariff?: number;

  /**  */
  secondTariff?: number;

  /**  */
  bikeTariff?: number;

  /**  */
  baseTicketClassId?: string;
}

export interface SaveSegmentTariffParameterModel {
  /**  */
  baseTariffParameterId?: string;

  /**  */
  segmentTariffParameterId?: string;

  /**  */
  parameterValueType?: SegmentTariffParameterValueType;

  /**  */
  parameterValue?: number;

  /**  */
  parameterReturnValue?: number;

  /**  */
  parameterDirection?: SegmentTariffParameterDirection;

  /**  */
  ticketTariffId?: string;

  /**  */
  baseTicketClassId?: string;

  /**  */
  applyForAllSegments?: boolean;
}

export interface SeatInfo {
  /**  */
  id?: string;

  /**  */
  row?: number;

  /**  */
  column?: number;

  /**  */
  ticketClassId?: string;

  /**  */
  name?: string;
}

export interface SeatingModelAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface SeatingModelDto {
  /**  */
  id?: string;

  /**  */
  seatingModelName?: string;

  /**  */
  seatingModelRef?: string;

  /**  */
  noOfRows?: number;

  /**  */
  seatingType?: SeatingType;
}

export interface SeatingModelDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SeatingModelDto[];
}

export interface SeatingModelExportRequest {
  /**  */
  seatingModelName?: string;

  /**  */
  seatingType?: SeatingType;

  /**  */
  columns: string[];
}

export interface SeatingModelSummary {
  /**  */
  busEntitySummaryList?: BusEntitySummary[];

  /**  */
  ticketClassSummaryList?: TicketClassSummary[];
}

export interface SegmentAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;
}

export interface SegmentTariffParameterDto {
  /**  */
  baseTariffParameterId?: string;

  /**  */
  tariffParameterCategory?: TariffCategory;

  /**  */
  tariffParameterCode?: string;

  /**  */
  tariffParameterName?: string;

  /**  */
  segmentTariffParameterId?: string;

  /**  */
  baseTicketClassId?: string;

  /**  */
  companyTicketClassName?: string;

  /**  */
  parameterValueType?: SegmentTariffParameterValueType;

  /**  */
  parameterValue?: number;

  /**  */
  parameterReturnValue?: number;

  /**  */
  parameterDirection?: SegmentTariffParameterDirection;
}

export interface SegmentTariffParameterDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SegmentTariffParameterDto[];
}

export interface SellOnTheGoBookingDetail {
  /**  */
  id?: string;

  /**  */
  bookingDate?: Date;

  /**  */
  bookingRefNo?: string;

  /**  */
  bookingRefNoOffline?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  receiptRefNoOffline?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  tripCode?: string;

  /**  */
  tripName?: string;

  /**  */
  distance?: number;

  /**  */
  noOfPassengers?: number;

  /**  */
  busName?: string;

  /**  */
  busNumber?: string;

  /**  */
  ticketAmount?: number;

  /**  */
  tickets?: SellOnTheGoTicketDetailsModel[];

  /**  */
  paymentRecords?: SellOnTheGoPaymentDetails[];
}

export interface SellOnTheGoBookingListingDto {
  /**  */
  bookingId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  sourceName?: string;

  /**  */
  destinationName?: string;

  /**  */
  tripName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  bookingDate?: Date;
}

export interface SellOnTheGoBookingListingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SellOnTheGoBookingListingDto[];
}

export interface SellOnTheGoFareConfigurationDto {
  /**  */
  id?: string;

  /**  */
  baseTariffParameterId?: string;

  /**  */
  tariffParameterName?: string;

  /**  */
  fromKms?: number;

  /**  */
  toKms?: number;

  /**  */
  tariffValue?: number;

  /**  */
  isInRate?: boolean;
}

export interface SellOnTheGoFareConfigurationDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SellOnTheGoFareConfigurationDto[];
}

export interface SellOnTheGoFareConfigurationModel {
  /**  */
  id?: string;

  /**  */
  tariffParameterId: string;

  /**  */
  fromKms: number;

  /**  */
  toKms: number;

  /**  */
  tariffValue: number;

  /**  */
  isInRate: boolean;
}

export interface SellOnTheGoPaymentDetails {
  /**  */
  payMode?: BookingPayMode;

  /**  */
  totalAmount?: number;

  /**  */
  cashChange?: number;

  /**  */
  cashTendered?: number;

  /**  */
  transactionFee?: number;

  /**  */
  transactionId?: string;

  /**  */
  approvalCode?: string;

  /**  */
  transactionMessage?: string;

  /**  */
  paymentDateTime?: Date;
}

export interface SellOnTheGoReconciliationDetailsModel {
  /**  */
  companyUserId?: string;

  /**  */
  userName?: string;

  /**  */
  companyUserFullName?: string;

  /**  */
  lastReconciliationDate?: Date;

  /**  */
  bookingTotalAmount?: number;

  /**  */
  bookingExpectedAmount?: number;

  /**  */
  bookingAmountGap?: number;

  /**  */
  shipmentTotalAmount?: number;

  /**  */
  allowReconciliation?: boolean;
}

export interface SellOnTheGoReconciliationPaymentDto {
  /**  */
  bookingId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  receiptRefNo?: string;

  /**  */
  noOfPassengers?: number;

  /**  */
  bookingDate?: Date;

  /**  */
  paymentDate?: Date;

  /**  */
  amount?: number;
}

export interface SellOnTheGoReconciliationPaymentDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SellOnTheGoReconciliationPaymentDto[];
}

export interface SellOnTheGoTicketDetailsModel {
  /**  */
  ticketId?: string;

  /**  */
  tariffParameterName?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  ticketRefNoOffline?: string;

  /**  */
  passengerFullName?: string;

  /**  */
  passengerPhoneCode?: string;

  /**  */
  passengerPhoneNumber?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  ticketAmount?: number;
}

export interface SellOnTheGoTicketListingDto {
  /**  */
  bookingId?: string;

  /**  */
  ticketId?: string;

  /**  */
  tripId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  bookingRefNoOffline?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  ticketRefNoOffline?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  passengerType?: string;

  /**  */
  passengerFullName?: string;

  /**  */
  passengerPhoneCode?: string;

  /**  */
  passengerPhoneNumber?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  createdOn?: Date;
}

export interface SellOnTheGoTicketListingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SellOnTheGoTicketListingDto[];
}

export interface SellStationSummaryReport {
  /**  */
  stationId?: string;

  /**  */
  stationName?: string;

  /**  */
  totalRecords?: number;

  /**  */
  ticketAmount?: number;

  /**  */
  discountAmount?: number;

  /**  */
  cancelledAmount?: number;

  /**  */
  modificationAmount?: number;

  /**  */
  modificationCount?: number;

  /**  */
  outStandingAmount?: number;
}

export interface SellerCashierOption {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface SellerOptionsModel {
  /**  */
  registers?: SellerRegisterOption[];

  /**  */
  cashiers?: SellerCashierOption[];
}

export interface SellerRegisterOption {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  stationName?: string;
}

export interface SendMailRequest {
  /**  */
  toEmails?: string;

  /**  */
  ccEmails?: string;

  /**  */
  bccEmails?: string;

  /**  */
  subject?: string;

  /**  */
  bodyContent?: string;
}

export interface SendNotificationRequest {
  /**  */
  message?: string;

  /**  */
  extraData?: string;

  /**  */
  isEnable?: boolean;

  /**  */
  toUserId?: string;
}

export interface SendTicketSmsMessageRequest {
  /**  */
  ticketId?: string;

  /**  */
  message?: string;
}

export interface SendTwoFactorCodeRequest {
  /**  */
  provider: string;

  /**  */
  twoFactorToken: string;
}

export interface ServiceAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface ServiceConfigurationDto {
  /**  */
  id?: string;

  /**  */
  serviceName?: string;

  /**  */
  countryName?: string;

  /**  */
  activationDate?: Date;

  /**  */
  availableApps?: string[];

  /**  */
  isEnabled?: boolean;

  /**  */
  description?: string;

  /**  */
  masterServiceType?: MasterService;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface ServiceConfigurationDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: ServiceConfigurationDto[];
}

export interface SetSupervisorPinRequest {
  /**  */
  currentPassword?: string;

  /**  */
  pin?: string;
}

export interface ShipmentCancellationPolicySettingModel {
  /**  */
  id?: string;

  /**  */
  isPercentageBase?: boolean;

  /**  */
  beforeAssignTripAmount?: number;

  /**  */
  plans?: CancellationPolicyPlan[];
}

export interface ShipmentInsuranceRangeBaseSetting {
  /**  */
  isPercentageBase?: boolean;

  /**  */
  from?: number;

  /**  */
  to?: number;

  /**  */
  value?: number;
}

export interface ShipmentTariffPagingDto {
  /**  */
  id?: string;

  /**  */
  sourceId?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationId?: string;

  /**  */
  destinationName?: string;

  /**  */
  boxCategoryId?: string;

  /**  */
  boxCategoryName?: string;

  /**  */
  boxWeightId?: string;

  /**  */
  boxWeightName?: string;

  /**  */
  boxVolumeId?: string;

  /**  */
  boxVolumeName?: string;

  /**  */
  tariffAmount?: number;
}

export interface ShipmentTariffPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: ShipmentTariffPagingDto[];
}

export interface SmsMessage {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  countryCode?: string;

  /**  */
  message?: string;

  /**  */
  fromPhoneNumber?: string;

  /**  */
  smsProvider?: SmsProvider;

  /**  */
  createdOn?: Date;

  /**  */
  sentOn?: Date;

  /**  */
  error?: string;

  /**  */
  isSent?: boolean;
}

export interface SmsMessagePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SmsMessage[];
}

export interface SmsTemplateDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  cultureCode?: string;

  /**  */
  content?: string;

  /**  */
  enabled?: boolean;
}

export interface SmsTemplateDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: SmsTemplateDto[];
}

export interface SmsTemplateModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  cultureCode?: string;

  /**  */
  content?: string;

  /**  */
  enabled?: boolean;
}

export interface SoftwareComponentDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  componentType?: SoftwareComponentType;
}

export interface SoftwareComponentExportRequest {
  /**  */
  columns?: string[];
}

export interface StationAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  countyId?: string;

  /**  */
  stationRef?: string;

  /**  */
  stationCode?: string;
}

export interface StationBalanceDto {
  /**  */
  id?: string;

  /**  */
  entityType?: StationBalanceEntityRef;

  /**  */
  stationEvent?: AccountEvent;

  /**  */
  stationAction?: AccountAction;

  /**  */
  currentBalance?: number;

  /**  */
  amountInvolved?: number;

  /**  */
  fileImageUrl?: string;

  /**  */
  fileImageName?: string;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdOn?: Date;
}

export interface StationBalanceDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: StationBalanceDto[];
}

export interface StationCurrentBalanceModel {
  /**  */
  stationId?: string;

  /**  */
  currentBalance?: number;
}

export interface StationModel {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  name?: string;

  /**  */
  stationRef?: string;

  /**  */
  stationCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  displayPhoneNumber?: string;

  /**  */
  email?: string;

  /**  */
  address?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  stationImageUrl?: string;

  /**  */
  quartierName?: string;

  /**  */
  isConnectionStation?: boolean;

  /**  */
  startingBalance?: number;

  /**  */
  currentBalance?: number;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  expenseApproverId?: string;

  /**  */
  stationAdministratorUsers?: StationUserModel[];

  /**  */
  stationSupervisorUsers?: StationUserModel[];
}

export interface StationModelPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: StationModel[];
}

export interface StationPrinterDto {
  /**  */
  id?: string;

  /**  */
  printerCompany?: PrinterCompany;

  /**  */
  printType?: PrintType;

  /**  */
  ipAddress?: string;

  /**  */
  deviceName?: string;
}

export interface StationPrinterDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: StationPrinterDto[];
}

export interface StationPrinterInfoModel {
  /**  */
  printerCompany?: PrinterCompany;

  /**  */
  printType?: PrintType;

  /**  */
  ipAddress?: string;

  /**  */
  deviceName?: string;

  /**  */
  companyDisplayName?: string;

  /**  */
  companyAddress?: string;

  /**  */
  companyLogoImageUrl?: string;
}

export interface StationPrinterModel {
  /**  */
  id?: string;

  /**  */
  stationId?: string;

  /**  */
  printerCompany?: PrinterCompany;

  /**  */
  printType?: PrintType;

  /**  */
  ipAddress?: string;

  /**  */
  deviceName?: string;
}

export interface StationUserModel {
  /**  */
  id?: string;

  /**  */
  stationId?: string;

  /**  */
  userId?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  roleName?: string;
}

export interface SupervisorPinStatusModel {
  /**  */
  isStationSupervisor?: boolean;

  /**  */
  hasPin?: boolean;

  /**  */
  blocked?: boolean;

  /**  */
  setOn?: Date;
}

export interface TariffAgeIssueModel {
  /**  */
  ticketId?: string;

  /**  */
  source?: TariffAgeIssueSource;

  /**  */
  ticketRefNo?: string;

  /**  */
  passengerName?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  tariffParameterId?: string;

  /**  */
  tariffName?: string;

  /**  */
  departureLocal?: Date;

  /**  */
  issue?: string;

  /**  */
  soldOn?: Date;

  /**  */
  reviewedOn?: Date;

  /**  */
  reviewedById?: string;

  /**  */
  reviewedBy?: string;
}

export interface TariffAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  category?: TariffCategory;

  /**  */
  code?: string;

  /**  */
  isStandard?: boolean;
}

export interface TariffParameterBasicInfo {
  /**  */
  id?: string;

  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  isStandard?: boolean;

  /**  */
  passengerType?: PassengerType;

  /**  */
  minAge?: number;

  /**  */
  maxAge?: number;
}

export interface TariffParameterDto {
  /**  */
  id?: string;

  /**  */
  baseTariffParameterId?: string;

  /**  */
  baseTariffParameterName?: string;

  /**  */
  code?: string;

  /**  */
  name?: string;

  /**  */
  isStandard?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  category?: TariffCategory;

  /**  */
  passengerType?: PassengerType;

  /**  */
  minAge?: number;

  /**  */
  maxAge?: number;
}

export interface TariffParameterDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TariffParameterDto[];
}

export interface TariffParameterModel {
  /**  */
  id?: string;

  /**  */
  baseTariffParameterId: string;

  /**  */
  code: string;

  /**  */
  name: string;

  /**  */
  isStandard?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  category?: TariffCategory;

  /**  */
  minAge?: number;

  /**  */
  maxAge?: number;
}

export interface TerminalEnrollmentCodeResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  terminal?: TerminalModel;

  /**  */
  enrollmentCode?: string;

  /**  */
  enrollmentCodeExpiresOn?: Date;
}

export interface TerminalModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  scopeType?: number;

  /**  */
  scopeId?: string;

  /**  */
  scopeName?: string;

  /**  */
  status?: string;

  /**  */
  deviceModel?: string;

  /**  */
  enrolledOn?: Date;

  /**  */
  lastSeenOn?: Date;

  /**  */
  lastUserName?: string;

  /**  */
  revokedOn?: Date;
}

export interface TerminalResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  terminal?: TerminalModel;
}

export interface TicketBaggageModel {
  /**  */
  baggageRefNo?: string;

  /**  */
  baggageType?: BaggageType;
}

export interface TicketBookingReportModel {
  /**  */
  monthlyReports?: CompanyMonthlyTicketReportDetail[];

  /**  */
  dailyReports?: CompanyDailyTicketReportDetail[];
}

export interface TicketCancellationPolicySettingDto {
  /**  */
  id?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  isPercentageBase?: boolean;

  /**  */
  plans?: CancellationPolicyPlan[];
}

export interface TicketCancellationPolicySettingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TicketCancellationPolicySettingDto[];
}

export interface TicketCancellationRequestDto {
  /**  */
  id?: string;

  /**  */
  ticketId?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  bookingTripIds?: string[];

  /**  */
  refundAmount?: number;

  /**  */
  cancellationFee?: number;

  /**  */
  reason?: string;

  /**  */
  status?: TicketCancellationRequestStatus;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  reviewedOn?: Date;

  /**  */
  reviewComment?: string;
}

export interface TicketClassAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  isStandard?: boolean;

  /**  */
  seatColor?: string;
}

export interface TicketClassSummary {
  /**  */
  ticketClassName?: string;

  /**  */
  count?: number;
}

export interface TicketConflictExportRequest {
  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  tripCode?: string;

  /**  */
  ticketStatus?: TicketStatus;

  /**  */
  passengerName?: string;
}

export interface TicketConflictListingDto {
  /**  */
  bookingId?: string;

  /**  */
  ticketId?: string;

  /**  */
  bookingTripId?: string;

  /**  */
  onlineBookingId?: string;

  /**  */
  bookingType?: BookingType;

  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  tripCode?: string;

  /**  */
  tripName?: string;

  /**  */
  isDeparture?: boolean;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  passengerFirstName?: string;

  /**  */
  passengerLastName?: string;

  /**  */
  passengerType?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  hasBaggage?: boolean;

  /**  */
  ticketStatus?: TicketStatus;

  /**  */
  conflictReason?: string;

  /**  */
  createdOn?: Date;
}

export interface TicketConflictListingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TicketConflictListingDto[];
}

export interface TicketDetailModel {
  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  seatName?: string;

  /**  */
  ticketCondition?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  busName?: string;

  /**  */
  busNo?: string;

  /**  */
  busDriver?: string;

  /**  */
  tripRefNo?: string;

  /**  */
  tripName?: string;

  /**  */
  noOfStops?: number;

  /**  */
  distance?: number;

  /**  */
  passengerInfo?: TicketPassengerModel;

  /**  */
  baggageList?: TicketBaggageModel[];
}

export interface TicketModificationHistoryModel {
  /**  */
  id?: string;

  /**  */
  oldTicketRefNo?: string;

  /**  */
  newTicketRefNo?: string;

  /**  */
  kinds?: TicketModificationKind[];

  /**  */
  changes?: ChangeValue[];

  /**  */
  oldAmount?: number;

  /**  */
  newAmount?: number;

  /**  */
  fee?: number;

  /**  */
  feeWaived?: boolean;

  /**  */
  difference?: number;

  /**  */
  settlement?: TicketModificationSettlement;

  /**  */
  creditNoteNumber?: string;

  /**  */
  modifiedBy?: string;

  /**  */
  registerName?: string;

  /**  */
  approvedBy?: string;

  /**  */
  createdOn?: Date;

  /**  */
  groupId?: string;

  /**  */
  groupTicketRefNos?: string[];
}

export interface TicketModificationPagingDto {
  /**  */
  id?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  ticketConditionName?: string;

  /**  */
  allowToModifyTicket?: boolean;

  /**  */
  isPercentageBase?: boolean;

  /**  */
  amount?: number;
}

export interface TicketModificationPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TicketModificationPagingDto[];
}

export interface TicketModificationPolicyModel {
  /**  */
  limitHoursBeforeDeparture?: number;

  /**  */
  effectiveLimitHours?: number;

  /**  */
  departureChangeFeePercent?: number;

  /**  */
  departureChangeFeeMinimum?: number;

  /**  */
  seatChangeFee?: number;

  /**  */
  freeNameCorrections?: number;

  /**  */
  maxModificationsPerTicket?: number;

  /**  */
  supervisorRefundThreshold?: number;

  /**  */
  creditNoteValidityMonths?: number;
}

export interface TicketPagingDto {
  /**  */
  bookingId?: string;

  /**  */
  onlineBookingId?: string;

  /**  */
  ticketId?: string;

  /**  */
  companyId?: string;

  /**  */
  companyName?: string;

  /**  */
  tripId?: string;

  /**  */
  tripName?: string;

  /**  */
  registerId?: string;

  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  isDeparture?: boolean;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  passengerFirstName?: string;

  /**  */
  passengerLastName?: string;

  /**  */
  passengerType?: string;

  /**  */
  seatName?: string;

  /**  */
  ticketClassName?: string;

  /**  */
  createdOn?: Date;

  /**  */
  baggageList?: TicketBaggageModel[];

  /**  */
  ticketStatus?: TicketStatus;

  /**  */
  isConflicted?: boolean;

  /**  */
  conflictReason?: string;

  /**  */
  refunded?: boolean;

  /**  */
  reprintCount?: number;
}

export interface TicketPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TicketPagingDto[];
}

export interface TicketPassengerIdentityModel {
  /**  */
  identityType?: IdentityDocumentType;

  /**  */
  documentNumber?: string;

  /**  */
  countryCode?: string;

  /**  */
  uploadDocuments?: string[];
}

export interface TicketPassengerModel {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  passengerType?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  emailAddress?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  address?: string;

  /**  */
  passengerIdentity?: TicketPassengerIdentityModel;
}

export interface TicketReprintHistoryModel {
  /**  */
  sequence?: number;

  /**  */
  reprintedOn?: Date;

  /**  */
  reprintedBy?: string;

  /**  */
  terminal?: string;

  /**  */
  register?: string;

  /**  */
  approvedBy?: string;
}

export interface TransportImportHistoryPagingDto {
  /**  */
  id?: string;

  /**  */
  importType?: ImportType;

  /**  */
  logFileUrl?: string;

  /**  */
  logFileName?: string;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdOn?: Date;
}

export interface TransportImportHistoryPagingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TransportImportHistoryPagingDto[];
}

export interface TransportNotificationContactDto {
  /**  */
  id?: string;

  /**  */
  notificationType?: NotificationContactType;

  /**  */
  countryPhoneCode?: string;

  /**  */
  contactName?: string;

  /**  */
  contactValue?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface TransportNotificationContactDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TransportNotificationContactDto[];
}

export interface TransportNotificationContactModel {
  /**  */
  id?: string;

  /**  */
  notificationType?: NotificationContactType;

  /**  */
  countryPhoneCode?: string;

  /**  */
  contactName?: string;

  /**  */
  contactValue?: string;
}

export interface TransportTicketSettingDto {
  /**  */
  id?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  companyDisplayName?: string;

  /**  */
  companyAddress?: string;

  /**  */
  companyLogoImageUrl?: string;
}

export interface TransportTicketSettingDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TransportTicketSettingDto[];
}

export interface TransportTicketSettingModel {
  /**  */
  id?: string;

  /**  */
  countryId: string;

  /**  */
  companyDisplayName: string;

  /**  */
  companyAddress: string;

  /**  */
  companyLogoImageUrl?: string;
}

export interface TransportVendorAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface TransportVendorDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  address?: string;

  /**  */
  email?: string;

  /**  */
  phoneNo?: string;

  /**  */
  vendorUniqueId?: string;

  /**  */
  vendorImageFileName?: string;

  /**  */
  vendorImageUrl?: string;

  /**  */
  countryId?: string;

  /**  */
  countryName?: string;

  /**  */
  regionId?: string;

  /**  */
  regionName?: string;

  /**  */
  cityId?: string;

  /**  */
  cityName?: string;

  /**  */
  contactFirstName?: string;

  /**  */
  contactLastName?: string;

  /**  */
  contactRole?: string;
}

export interface TransportVendorDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TransportVendorDto[];
}

export interface TransportVendorModel {
  /**  */
  id?: string;

  /**  */
  name: string;

  /**  */
  address?: string;

  /**  */
  email: string;

  /**  */
  phoneNo?: string;

  /**  */
  vendorImageFileName?: string;

  /**  */
  vendorImageUrl?: string;

  /**  */
  countryId: string;

  /**  */
  regionId: string;

  /**  */
  cityId: string;

  /**  */
  contactFirstName?: string;

  /**  */
  contactLastName?: string;

  /**  */
  contactRole?: string;
}

export interface TripAssignmentModel {
  /**  */
  id?: string;

  /**  */
  tripRefNo?: string;

  /**  */
  status?: TripStatus;

  /**  */
  numberOfPassenger?: number;

  /**  */
  numberOfAssignSeats?: number;

  /**  */
  numberOfConflictedTicket?: number;

  /**  */
  seatingModelId?: string;

  /**  */
  routeId?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  driverId?: string;

  /**  */
  driver?: string;

  /**  */
  coDriverId?: string;

  /**  */
  coDriver?: string;

  /**  */
  busId?: string;

  /**  */
  busName?: string;

  /**  */
  busPlateNumber?: string;
}

export interface TripAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  tripInternalCode?: string;

  /**  */
  tripRefNumber?: string;
}

export interface TripAvailableModel {
  /**  */
  tripId?: string;

  /**  */
  tripCode?: string;

  /**  */
  tripName?: string;

  /**  */
  sourceStationId?: string;

  /**  */
  sourceStationName?: string;

  /**  */
  sourceCityName?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  destinationCityName?: string;

  /**  */
  departureDateTime?: Date;

  /**  */
  arrivalDateTime?: Date;

  /**  */
  duration?: number;

  /**  */
  noOfStops?: number;

  /**  */
  availableSeats?: number;

  /**  */
  cheapestPrice?: number;

  /**  */
  busName?: string;

  /**  */
  tripStatus?: TripStatus;

  /**  */
  busBrand?: string;

  /**  */
  busPlateNumber?: string;

  /**  */
  driver?: string;

  /**  */
  coDriver?: string;

  /**  */
  totalSeats?: number;

  /**  */
  companyName?: string;

  /**  */
  companyLogoUrl?: string;
}

export interface TripAvailableRequest {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  orderBy?: string;

  /**  */
  orderByAsc?: boolean;

  /**  */
  journeyType?: JourneyType;

  /**  */
  sourceStationId?: string;

  /**  */
  destinationStationId?: string;

  /**  */
  departureDate?: Date;

  /**  */
  departureTimeFrom?: string;

  /**  */
  departureTimeTo?: string;

  /**  */
  returnDate?: Date;

  /**  */
  returnTimeFrom?: string;

  /**  */
  returnTimeTo?: string;

  /**  */
  ticketClassId?: string;

  /**  */
  ticketConditionId?: string;

  /**  */
  bookingTariffParameters?: BookingTariffParameter[];
}

export interface TripAvailableResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  departureTrips?: TripAvailableModel[];

  /**  */
  returnTrips?: TripAvailableModel[];
}

export interface TripBusDetailsModel {
  /**  */
  tripId?: string;

  /**  */
  busName?: string;

  /**  */
  busRefNo?: string;

  /**  */
  plateNumber?: string;
}

export interface TripCurrentLocationModel {
  /**  */
  tripDetailId?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;
}

export interface TripDetailCalendarDto {
  /**  */
  id?: string;

  /**  */
  tripName?: string;

  /**  */
  tripRefNumber?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  status?: TripStatus;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  plannedArrivalDateTime?: Date;
}

export interface TripDetailCalendarDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TripDetailCalendarDto[];
}

export interface TripDetailDto {
  /**  */
  id?: string;

  /**  */
  tripName?: string;

  /**  */
  tripRefNumber?: string;

  /**  */
  routeName?: string;

  /**  */
  sourceId?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationId?: string;

  /**  */
  destinationName?: string;

  /**  */
  seatingModelName?: string;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  tripStops?: TripStopDto[];

  /**  */
  status?: TripStatus;
}

export interface TripDetailDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TripDetailDto[];
}

export interface TripDetailModel {
  /**  */
  id?: string;

  /**  */
  tripRefNo?: string;

  /**  */
  routeId?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  plannedArrivalDateTime?: Date;

  /**  */
  tripStatus?: TripStatus;

  /**  */
  tripDetailStops?: TripDetailStop[];
}

export interface TripDetailStop {
  /**  */
  routeStopId?: string;

  /**  */
  stationId?: string;

  /**  */
  sequence?: number;

  /**  */
  plannedArrivalDateTime?: Date;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  actualArrivalDateTime?: Date;

  /**  */
  actualDepartureDateTime?: Date;

  /**  */
  plannedStopTime?: Date;

  /**  */
  isConnectionPoint?: boolean;
}

export interface TripDirectionDto {
  /**  */
  fromStationId?: string;

  /**  */
  toStationId?: string;

  /**  */
  directionPreview?: string;
}

export interface TripDto {
  /**  */
  id?: string;

  /**  */
  tripName?: string;

  /**  */
  routeName?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationName?: string;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  plannedArrivalDateTime?: Date;

  /**  */
  noOfStops?: number;

  /**  */
  status?: TripStatus;

  /**  */
  isActive?: boolean;

  /**  */
  isRecurred?: boolean;
}

export interface TripDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TripDto[];
}

export interface TripExportRequest {
  /**  */
  searchText?: string;

  /**  */
  routeId?: string;

  /**  */
  departureDate?: Date;

  /**  */
  columns: string[];
}

export interface TripGroupAutocompletionModel {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface TripGroupModel {
  /**  */
  id?: string;

  /**  */
  name: string;
}

export interface TripLocationDto {
  /**  */
  id?: string;

  /**  */
  routeLocationId?: string;

  /**  */
  name?: string;

  /**  */
  latitude?: number;

  /**  */
  longitude?: number;

  /**  */
  placeId?: string;

  /**  */
  stationId?: string;

  /**  */
  order?: number;
}

export interface TripModel {
  /**  */
  id?: string;

  /**  */
  tripName?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  routeId?: string;

  /**  */
  tripGroupId?: string;

  /**  */
  plannedArrivalDateTime?: Date;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  isActive?: boolean;

  /**  */
  isRecurred?: boolean;

  /**  */
  recurrenceNumDays?: number[];

  /**  */
  recurrenceNumDaysStr?: string;

  /**  */
  tripStops?: TripStopModel[];
}

export interface TripPassengerModel {
  /**  */
  bookingRefNo?: string;

  /**  */
  ticketRefNo?: string;

  /**  */
  sourceId?: string;

  /**  */
  sourceName?: string;

  /**  */
  destinationId?: string;

  /**  */
  destinationName?: string;

  /**  */
  seatNo?: string;

  /**  */
  passengerType?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  contactPhoneCode?: string;

  /**  */
  contactPhoneNumber?: string;

  /**  */
  status?: TicketStatus;

  /**  */
  baggageList?: TicketBaggageModel[];
}

export interface TripSearchResponse {
  /**  */
  tripName?: string;

  /**  */
  baseTripId?: string;

  /**  */
  seatingModelId?: string;

  /**  */
  seatingModelName?: string;

  /**  */
  routeName?: string;

  /**  */
  sourceStationName?: string;

  /**  */
  destinationStationName?: string;

  /**  */
  departureDatetime?: Date;

  /**  */
  arrivalDatetime?: Date;

  /**  */
  tripStatus?: TripStatus;

  /**  */
  tripStops?: TripStopSearchModel[];
}

export interface TripSearchResponsePagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: TripSearchResponse[];
}

export interface TripSeatingModel {
  /**  */
  tripId?: string;

  /**  */
  seatingModelName?: string;

  /**  */
  seatingModelRef?: string;

  /**  */
  noOfRows?: number;

  /**  */
  seatingType?: SeatingType;

  /**  */
  seats?: AvailableSeatModel[];
}

export interface TripStatusModel {
  /**  */
  tripId?: string;

  /**  */
  status?: TripStatus;
}

export interface TripStatusReportDto {
  /**  */
  tripName?: string;

  /**  */
  departureDatetime?: Date;

  /**  */
  busNo?: string;

  /**  */
  sourceStation?: string;

  /**  */
  destinationStation?: string;

  /**  */
  noOfStops?: number;

  /**  */
  status?: TripStatus;

  /**  */
  delayedMinutes?: number;

  /**  */
  recurrenceNumDays?: number[];
}

export interface TripStopDto {
  /**  */
  stationId?: string;

  /**  */
  stationName?: string;

  /**  */
  distance?: number;

  /**  */
  plannedDepartureDateTime?: Date;
}

export interface TripStopModel {
  /**  */
  routeStopId?: string;

  /**  */
  stationId?: string;

  /**  */
  plannedArrivalDateTime?: Date;

  /**  */
  plannedDepartureDateTime?: Date;

  /**  */
  isConnectionPoint?: boolean;
}

export interface TripStopSearchModel {
  /**  */
  stationName?: string;

  /**  */
  departureDatetime?: Date;

  /**  */
  arrivalDatetime?: Date;
}

export interface TripTravelerPdfReportRequest {
  /**  */
  tripId?: string;

  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;
}

export interface TripTravelerReportEmailRequest {
  /**  */
  tripId?: string;

  /**  */
  emailAddress?: string;

  /**  */
  sourceId?: string;

  /**  */
  destinationId?: string;
}

export interface UpdateAccessRequirementDetailModel {
  /**  */
  userType?: UserType;

  /**  */
  twoFactorEnabled?: boolean;
}

export interface UpdateAccessRequirementModel {
  /**  */
  accessRequirements?: UpdateAccessRequirementDetailModel[];
}

export interface UpdateBasicTariffModel {
  /**  */
  id?: string;

  /**  */
  amount?: number;

  /**  */
  returnAmount?: number;

  /**  */
  baseTicketClassId?: string;

  /**  */
  distance?: number;
}

export interface UpdateCompanyModel {
  /**  */
  id?: string;

  /**  */
  isSmsNotificationAllowed?: boolean;

  /**  */
  planId?: string;

  /**  */
  commercialMemberId?: string;

  /**  */
  qrAccountId?: string;
}

export interface UpdateCompanyRoleModel {
  /**  */
  id?: string;

  /**  */
  isTransportRole?: boolean;

  /**  */
  isPOSRole?: boolean;

  /**  */
  permissions?: string[];
}

export interface UpdateCompanyUserModel {
  /**  */
  employeeUniqueId?: string;

  /**  */
  employeeCode?: string;

  /**  */
  isMobilePaymentSelected?: boolean;

  /**  */
  isBankPaymentSelected?: boolean;

  /**  */
  isCashPaymentSelected?: boolean;

  /**  */
  mobileAccountNumber?: string;

  /**  */
  bankAccountNumber?: string;

  /**  */
  mobileAccountPortion?: number;

  /**  */
  bankAccountPortion?: number;

  /**  */
  cashPortion?: number;

  /**  */
  id?: string;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  canLogin?: boolean;

  /**  */
  imgUrl?: string;

  /**  */
  imgFileName?: string;

  /**  */
  remarks?: string;

  /**  */
  roles: string[];

  /**  */
  permissions?: string[];

  /**  */
  jobTitle?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  employeeCategoryId?: string;

  /**  */
  employeeType?: EmployeeType;

  /**  */
  employeeStartDate?: Date;

  /**  */
  isCadre?: boolean;

  /**  */
  igrParts?: number;

  /**  */
  contractType?: string;

  /**  */
  seniority?: string;

  /**  */
  cnpsId?: string;

  /**  */
  employment?: string;

  /**  */
  salaryCategory?: string;

  /**  */
  qualification?: string;
}

export interface UpdateGlobalCashierSellingAssignmentModel {
  /**  */
  cashierId?: string;

  /**  */
  companyIds?: string[];
}

export interface UpdateGlobalRoleModel {
  /**  */
  id?: string;

  /**  */
  permissions?: string[];
}

export interface UpdateGlobalUserModel {
  /**  */
  id?: string;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  phoneCode: string;

  /**  */
  phoneNumber: string;

  /**  */
  imageUrl?: string;

  /**  */
  imageFileName?: string;

  /**  */
  remarks?: string;

  /**  */
  roles: string[];

  /**  */
  reportingManagerId?: string;
}

export interface UpdatePassengerIdentityModel {
  /**  */
  passengerId?: string;

  /**  */
  identityType?: IdentityDocumentType;

  /**  */
  uploadDocuments?: string[];

  /**  */
  documentNumber?: string;

  /**  */
  countryCode?: string;
}

export interface UpdatePassengerModel {
  /**  */
  id?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  dateOfBirth?: Date;

  /**  */
  address?: string;

  /**  */
  profession?: string;

  /**  */
  phoneCode?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  gender?: PassengerGender;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  cityId?: string;

  /**  */
  postalCode?: string;

  /**  */
  isTicketBookingAllowed?: boolean;
}

export interface UpdatePasswordPolicyModel {
  /**  */
  id: string;

  /**  */
  passwordLength?: number;

  /**  */
  noOfUpperCase?: number;

  /**  */
  noOfLowerCase?: number;

  /**  */
  noOfSpecialCharacters?: number;

  /**  */
  noOfNumericCharacters?: number;

  /**  */
  allowNameCharacters?: boolean;

  /**  */
  preventPasswordReuse?: boolean;

  /**  */
  passwordExpirationDays?: number;
}

export interface UpdateRegisterBalanceModel {
  /**  */
  registerId?: string;

  /**  */
  type?: UpdateRegisterBalanceType;

  /**  */
  amount?: number;

  /**  */
  description?: string;
}

export interface UpdateRegisterModel {
  /**  */
  id?: string;

  /**  */
  registerName?: string;

  /**  */
  openingHoursFrom?: string;

  /**  */
  openingHoursTo?: string;

  /**  */
  stationId?: string;

  /**  */
  startingCash?: number;

  /**  */
  printDestination?: PrintDestination;

  /**  */
  loyaltyClient?: boolean;

  /**  */
  actionAnnulation?: boolean;

  /**  */
  receiptDefaultPrinter?: ReceiptPrinter;

  /**  */
  ticketDefaultPrinter?: TicketPrinter;

  /**  */
  shipmentLabelDefaultPrinter?: ShipmentLabelPrinter;

  /**  */
  registerCashiersUserIds?: string[];
}

export interface UpdateRegisterStatusModel {
  /**  */
  id?: string;

  /**  */
  status?: RegisterStatus;
}

export interface UpdateRolesModel {
  /**  */
  userId: string;

  /**  */
  roles: string[];
}

export interface UpdateSoftwareComponentModel {
  /**  */
  components?: UpdateSoftwareComponentModelDetail[];
}

export interface UpdateSoftwareComponentModelDetail {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  componentType?: SoftwareComponentType;

  /**  */
  price?: number;

  /**  */
  availableApps?: SystemApp[];
}

export interface UpdateStationBalanceModel {
  /**  */
  stationId?: string;

  /**  */
  amount?: number;

  /**  */
  stationType?: StationBalanceType;

  /**  */
  stationAction?: AccountAction;

  /**  */
  description?: string;

  /**  */
  companyAccountId?: string;

  /**  */
  partnerId?: string;

  /**  */
  imageUrl?: string;

  /**  */
  imageName?: string;
}

export interface UpdateTripAssignmentModel {
  /**  */
  id?: string;

  /**  */
  driverId?: string;

  /**  */
  coDriverId?: string;

  /**  */
  busId?: string;
}

export interface UpdateTripDetailModel {
  /**  */
  id?: string;

  /**  */
  plannedDepartureDatetime?: Date;

  /**  */
  plannedArrivalDatetime?: Date;

  /**  */
  tripStops?: TripStopModel[];
}

export interface UpdateTripStatusModel {
  /**  */
  id?: string;

  /**  */
  status?: TripStatus;

  /**  */
  remarks?: string;

  /**  */
  delayedMinutes?: number;

  /**  */
  actualDateTime?: Date;
}

export interface UpdateUserPermissionsModel {
  /**  */
  userId?: string;

  /**  */
  permissions?: string[];
}

export interface UpdateUserProfileModel {
  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  phone?: string;
}

export interface UserBasicInfoModel {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  userName?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  emailAddress?: string;

  /**  */
  countryId?: string;

  /**  */
  roles?: string[];
}

export interface UtilityPartnerConnectivityDetailModel {
  /**  */
  id?: string;

  /**  */
  utilityPartnerId?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  isPasswordSet?: boolean;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  encryptionType?: EncryptionType;

  /**  */
  decryptionKey?: string;

  /**  */
  encryptionKey?: string;

  /**  */
  provider?: number;

  /**  */
  provider2?: number;

  /**  */
  payId?: number;

  /**  */
  payId2?: number;

  /**  */
  controller?: string;

  /**  */
  dataType?: string;

  /**  */
  isOwnPrivateKeySet?: boolean;

  /**  */
  orangePublicKey?: string;

  /**  */
  operatorId?: string;

  /**  */
  appId?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface UtilityPartnerConnectivityDto {
  /**  */
  id?: string;

  /**  */
  ipAddress?: string;

  /**  */
  port?: number;

  /**  */
  userName?: string;

  /**  */
  method?: string;

  /**  */
  interface?: number;

  /**  */
  ssId?: string;

  /**  */
  systemProvider?: string;

  /**  */
  systemVersion?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface UtilityPartnerConnectivityDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: UtilityPartnerConnectivityDto[];
}

export interface UtilityPartnerDetail {
  /**  */
  id?: string;

  /**  */
  providerInterface?: number;

  /**  */
  partnerName?: string;

  /**  */
  address?: string;

  /**  */
  cityId?: string;

  /**  */
  countryId?: string;

  /**  */
  regionId?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  monetaryZone?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface UtilityPartnerDto {
  /**  */
  id?: string;

  /**  */
  providerInterface?: number;

  /**  */
  partnerName?: string;

  /**  */
  address?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  technicalPhoneNumber?: string;

  /**  */
  contactEmail?: string;

  /**  */
  technicalSupportEmail?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  monetaryZone?: string;

  /**  */
  createdOn?: Date;

  /**  */
  createdById?: string;

  /**  */
  createdBy?: string;

  /**  */
  updatedOn?: Date;

  /**  */
  updatedById?: string;

  /**  */
  updatedBy?: string;
}

export interface UtilityPartnerDtoPagingResponse {
  /**  */
  pageIndex?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  data?: UtilityPartnerDto[];
}

export interface UtilityPartnerExportRequest {
  /**  */
  searchText?: string;

  /**  */
  columns: string[];
}

export interface VerifyTwoFactorCodeRequest {
  /**  */
  twoFactorToken: string;

  /**  */
  code: string;

  /**  */
  provider: string;
}

export interface VideoUploadResponse {
  /**  */
  success?: boolean;

  /**  */
  message?: string;

  /**  */
  videoUri?: string;

  /**  */
  videoId?: string;
}

export interface WithoutPhoneCountModel {
  /**  */
  userId?: string;

  /**  */
  cashierName?: string;

  /**  */
  tickets?: number;

  /**  */
  lastSale?: Date;
}

export type AccountAction = 1 | 2;

export type AccountEvent = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type AdvertisingClickAction = 1 | 2 | 3;

export type AdvertisingDetailType = 1 | 2;

export type AdvertisingScreen = 1 | 2;

export type AdvertisingType = 1 | 2;

export type BaggageType = 1 | 2 | 3;

export type BookingPayMode = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type BookingStatus = 1 | 2 | 3;

export type BookingType = 1 | 2 | 3;

export type BusEntityType = 1 | 2 | 3 | 4 | 5;

export type BusInsuranceStatus = 1 | 2;

export type CompanyAccountType = 1 | 2;

export type CompanyDashboardReportType = 1 | 2;

export type ConfirmationBookingNotification = 0 | 1 | 2 | 3;

export type DiscountApplicationTarget = 1 | 2;

export type DiscountBeneficiaryType = 1 | 3 | 4;

export type DiscountCompany = 1 | 2;

export type DiscountTargetType = 1 | 2 | 3;

export type DiscountUsage = 1 | 2;

export type DiscountUser = 1 | 2 | 3 | 4;

export type DiscountValueType = 1 | 2;

export type EmployeeType = 1 | 2;

export type EncryptionType = 1 | 2 | 3 | 4 | 5 | 6;

export type GlobalDiscountType = 1 | 2;

export type IdentityDocumentType = 1 | 2;

export type ImportType = 1 | 2 | 3;

export type JourneyType = 0 | 1;

export type MasterService = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type MtopoApplication = 1 | 2 | 3;

export type NotificationCategoryType = 1 | 2;

export type NotificationContactType = 1 | 2;

export type NotificationModuleType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23;

export type PartnerAccountType = 1 | 2;

export type PassengerGender = 1 | 2;

export type PassengerType = 1 | 2 | 3;

export type PaymentMode = 0 | 1;

export type PaymentPartnerType = 1 | 2;

export type PaymentTerms = 0 | 1;

export type PlanType = 1 | 2 | 3;

export type PrintDestination = 1 | 2;

export type PrintType = 1 | 2;

export type PrinterCompany = 1 | 2;

export type ReceiptPrinter = 1 | 2 | 3 | 4;

export type RegisterStatus = 1 | 2 | 3;

export type RouteType = 1 | 2;

export type SeatStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type SeatingType = 1 | 2 | 3 | 4;

export type SegmentTariffParameterDirection = 1 | 2;

export type SegmentTariffParameterValueType = 1 | 2;

export type ServiceFeePayingEntityType = 1 | 2 | 3 | 4;

export type ServiceFeeSharingEntityType = 1 | 3 | 4 | 5;

export type ShipmentInsuranceSettingType = 1 | 2 | 3;

export type ShipmentLabelPrinter = 1 | 2 | 3 | 4 | 5;

export type ShipmentStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

export type SmsProvider = 1 | 2;

export type SoftwareComponentType = 1 | 2;

export type StationBalanceEntityRef = 1 | 2 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

export type StationBalanceType = 1 | 2;

export type SystemApp = 1 | 2 | 3;

export type TariffAgeIssueSource = 1 | 2;

export type TariffCategory = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type TicketCancellationRequestStatus = 1 | 2 | 3 | 4;

export type TicketModificationKind = 1 | 2 | 4 | 8 | 16 | 32 | 64;

export type TicketModificationSettlement = 1 | 2 | 3 | 4 | 5 | 6;

export type TicketPrinter = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type TicketStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export type TripRouteType = 1 | 2 | 3 | 4;

export type TripStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export type UpdateRegisterBalanceType = 1 | 2;

export type UserFollowUpType = 1 | 2 | 3 | 4 | 5 | 6;

export type UserSource = 1 | 2 | 3;

export type UserType = 1 | 2;

export type VideoPlayerType = 1 | 2;
